import React, { useContext, useRef, useState, useEffect, Fragment, forwardRef, useImperativeHandle } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import clonedeep from 'lodash.clonedeep';
import GA from 'react-ga';
import jhttp from 'jhttp';
import { createClient } from 'pexels';
import * as filestack from 'filestack-js';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var ZuploaderSource;

(function (ZuploaderSource) {
  ZuploaderSource["album"] = "album";
  ZuploaderSource["camera"] = "camera";
  ZuploaderSource["stock"] = "stock";
  ZuploaderSource["cloud"] = "cloud";
  ZuploaderSource["social"] = "social";
})(ZuploaderSource || (ZuploaderSource = {}));

var createObjectURL = (window.URL || window.webkitURL).createObjectURL;
var loadImage = function loadImage(base64) {
  return new Promise(function (resolve, reject) {
    var image = new Image();
    image.crossOrigin = 'anonymous';

    image.onload = function () {
      return resolve(image);
    };

    image.onerror = reject;
    image.src = base64;
  });
};
var disposeCanvas = function disposeCanvas(canvas) {
  canvas.width = canvas.height = 0;
};
var uuid = function uuid() {
  var s = [];
  var hexDigits = '0123456789abcdef';

  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }

  s[14] = '4';
  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = '-';
  return s.join('');
};
var createKey = function createKey() {
  return "zuploader/" + new Date().getFullYear() + (new Date().getMonth() + 1) + new Date().getDate() + "/" + uuid();
};
var getToken7n = function getToken7n(bucket) {
  if (bucket === void 0) {
    bucket = 'sunzi_ai';
  }

  return __awaiter(void 0, void 0, void 0, function () {
    var expire, token, response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          expire = localStorage.getItem('_sunzi_token7n_expire');
          token = localStorage.getItem('_sunzi_token7n');
          if (token && expire && new Date(expire).getTime() - new Date().getTime() > 60 * 1000) return [2, token];
          return [4, jhttp.get(host7n.token + "/qiniu/token/bucket", {
            bucket: bucket
          })];

        case 1:
          response = _a.sent();

          if (response.error === 0) {
            localStorage.setItem('_sunzi_token7n_expire', (response.expire * 1000).toString());
            localStorage.setItem('_sunzi_token7n', response.token);
            return [2, response.token];
          }

          return [2, ''];
      }
    });
  });
};
var createZuploaderImage = function createZuploaderImage(file, source) {
  return __awaiter(void 0, void 0, void 0, function () {
    var objectURL, image, width, height;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          objectURL = createObjectURL(file);
          return [4, loadImage(objectURL)];

        case 1:
          image = _a.sent();
          width = image.width, height = image.height;
          return [2, {
            objectURL: objectURL,
            source: source,
            width: width,
            height: height,
            retryCount: 0
          }];
      }
    });
  });
};
var upload7n = function upload7n(params, onprogress) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();

    xhr.upload.onprogress = function (e) {
      if (e.total > 0) onprogress && onprogress(e.loaded / e.total * 100);
    };

    var formData = new FormData();
    formData.append('file', params.file);
    formData.append('token', params.token);
    formData.append('key', params.key);
    xhr.timeout = 30 * 1000;

    xhr.onload = function () {
      if (xhr.status < 200 || xhr.status >= 300) reject();else {
        var text = xhr.responseText || xhr.response;

        try {
          return resolve(JSON.parse(text));
        } catch (e) {
          reject();
        }
      }
    };

    xhr.onerror = reject;
    xhr.open('post', params.bucket || host7n['upload-na0'], true);
    xhr.send(formData);
  });
};
var download = function download(url, onprogress) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.responseType = 'blob';
    xhr.timeout = 30 * 1000;

    xhr.onprogress = function (event) {
      if (event.lengthComputable) onprogress && onprogress(event.loaded / event.total);
    };

    xhr.onload = function () {
      if (xhr.readyState === 4 && xhr.status === 200) resolve(URL.createObjectURL(xhr.response));
    };

    xhr.onerror = reject;
    xhr.ontimeout = reject;
    xhr.send();
  });
};
var urlToBlob = function urlToBlob(url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';

    xhr.onload = function () {
      if (this.status === 200) resolve(this.response);
    };

    xhr.onerror = reject;
    xhr.ontimeout = reject;
    xhr.send();
  });
};
var gtag = function gtag(action, label) {
  GA.event({
    category: 'zuploader',
    action: action,
    label: label
  });
};

var defaultCategory = ['abstract', 'animals', 'pop', 'landscape', 'paintings', 'kids', 'textures', 'landmarks', 'floral', 'space', 'pink'];
var stockClientKey = '563492ad6f9170000100000111590f7c109142329e63f36d576ce6eb';
var fileStackKey = 'AEbSnRtPeRlSSNDk9fz54z';
var stockPageSize = 60;
var stockEndThreshold = 30;
var gaid = 'UA-174675922-4';

var enUS = {
	"zuploader.choose.source.title": "Choose photos source",
	"zuploader.from.album": "Choose from your album",
	"zuploader.from.camera": "Take A Photo",
	"zuploader.from.stock": "Stock photos",
	"zuploader.from.stock.subtitle": "2.2 Million Photos from Pexels",
	"zuploader.from.social": "Choose from Online Services",
	"zuploader.from.cloud": "My cloud album",
	"zuploader.cancel": "Cancel",
	"zuploader.min.count.title": "At least $value photos",
	"zuploader.min.count.subtitle": "You can upload  1 - $value photos",
	"zuploader.subtitle.wait.upload": "Waiting for upload",
	"zuploader.subtitle.uploading": "uploading",
	"zuploader.confirm": "confirm",
	"zuploader.replace": "replace",
	"zuploader.stop": "stop",
	"zuploader.upload": "upload",
	"zuploader.upload.now": "upload now",
	"zuploader.upload.error": "Upload Error, Please try again",
	"zuploader.add.photos": "add photos",
	"zuploader.replace.photo": "replace photo",
	"zuploader.empty.title": "None",
	"zuploader.low.quality.title": "Low Quality Image",
	"zuploader.low.quality.tips": "This photo is too small. It will probably make a blurry item!",
	"zuploader.low.quality.keep": "Keep Anyway",
	"zuploader.low.quality.remove": "Remove",
	"zuploader.low.quality.skip": "skip all",
	"zuploader.download.title": "Downloading",
	"zuploader.download.count": "totally $value photos",
	"zuploader.download.index": "The $value photo",
	"zuploader.power.by": "power by"
};

var enGB = {
	"zuploader.choose.source.title": "Choose photos source",
	"zuploader.from.album": "Choose from your album",
	"zuploader.from.camera": "Take A Photo",
	"zuploader.from.stock": "Stock photos",
	"zuploader.from.stock.subtitle": "2.2 Million Photos from Pexels",
	"zuploader.from.social": "Choose from Online Services",
	"zuploader.from.cloud": "My cloud album",
	"zuploader.cancel": "Cancel",
	"zuploader.min.count.title": "At least $value photos",
	"zuploader.min.count.subtitle": "You can upload  1 - $value photos",
	"zuploader.subtitle.wait.upload": "Waiting for upload",
	"zuploader.subtitle.uploading": "uploading",
	"zuploader.confirm": "confirm",
	"zuploader.replace": "replace",
	"zuploader.stop": "stop",
	"zuploader.upload": "upload",
	"zuploader.upload.now": "upload now",
	"zuploader.upload.error": "Upload Error, Please try again",
	"zuploader.add.photos": "add photos",
	"zuploader.replace.photo": "replace photo",
	"zuploader.empty.title": "None",
	"zuploader.low.quality.title": "Low Quality Image",
	"zuploader.low.quality.tips": "This photo is too small. It will probably make a blurry item!",
	"zuploader.low.quality.keep": "Keep Anyway",
	"zuploader.low.quality.remove": "Remove",
	"zuploader.low.quality.skip": "skip all",
	"zuploader.download.title": "Downloading",
	"zuploader.download.count": "totally $value photos",
	"zuploader.download.index": "The $value photo",
	"zuploader.power.by": "power by"
};

var esES = {
	"zuploader.choose.source.title": "Elija fuente de fotos",
	"zuploader.from.album": "Elige de tu álbum",
	"zuploader.from.camera": "Tomar fotos",
	"zuploader.from.stock": "Almacén de fotos",
	"zuploader.from.stock.subtitle": "2,2 millones de fotos de Pexels",
	"zuploader.from.social": "Elija de servicios en línea",
	"zuploader.from.cloud": "Mi álbum en la nube",
	"zuploader.cancel": "Cancelar",
	"zuploader.min.count.title": "Al menos $value fotos",
	"zuploader.min.count.subtitle": "Puedes subir 1 - $value fotos",
	"zuploader.subtitle.wait.upload": "Esperando subida",
	"zuploader.subtitle.uploading": "subiendo",
	"zuploader.confirm": "confirmar",
	"zuploader.replace": "reemplazar",
	"zuploader.stop": "detener",
	"zuploader.upload": "subir",
	"zuploader.upload.now": "subir ahora",
	"zuploader.upload.error": "Error al subir, vuelve a intentarlo.",
	"zuploader.add.photos": "agregar fotos",
	"zuploader.replace.photo": "reemplazar foto",
	"zuploader.empty.title": "Ninguno",
	"zuploader.low.quality.title": "Imagen de baja calidad",
	"zuploader.low.quality.tips": "Esta foto es demasiado pequeña. ¡Probablemente hará un elemento borroso! ",
	"zuploader.low.quality.keep": "Mantener",
	"zuploader.low.quality.remove": "Eliminar",
	"zuploader.low.quality.skip": "omitir todo",
	"zuploader.download.title": "Descargando",
	"zuploader.download.count": "totalmente $value fotos",
	"zuploader.download.index": "La $value foto",
	"zuploader.power.by": "desarrollado por"
};

var deDE = {
	"zuploader.choose.source.title": "Wählen Sie Fotos Quelle",
	"zuploader.from.album": "Wählen Sie aus Ihrem Album",
	"zuploader.from.camera": "Lager Fotos",
	"zuploader.from.stock": "Lager Fotos",
	"zuploader.from.stock.subtitle": "2,2 Millionen Fotos von Pexels",
	"zuploader.from.social": "Wählen Sie aus Online-Diensten",
	"zuploader.from.cloud": "Mein Cloud-Album",
	"zuploader.cancel": "Stornieren",
	"zuploader.min.count.title": "Mindestens $value Fotos",
	"zuploader.min.count.subtitle": "Sie können 1 - $value Fotos hochladen",
	"zuploader.subtitle.wait.upload": "Auf Upload warten",
	"zuploader.subtitle.uploading": "Hochladen",
	"zuploader.confirm": "bestätigen",
	"zuploader.replace": "ersetzen",
	"zuploader.stop": "Stopp",
	"zuploader.upload": "hochladen",
	"zuploader.upload.now": "jetzt hochladen",
	"zuploader.upload.error": "Upload-Fehler, bitte versuchen Sie es erneut",
	"zuploader.add.photos": "Fotos hinzufügen",
	"zuploader.replace.photo": "Foto ersetzen",
	"zuploader.empty.title": "Keiner",
	"zuploader.low.quality.title": "Bild von geringer Qualität",
	"zuploader.low.quality.tips": "Dieses Foto ist zu klein. Es wird wahrscheinlich einen verschwommenen Gegenstand machen!",
	"zuploader.low.quality.keep": "Wie auch immer",
	"zuploader.low.quality.remove": "Entfernen",
	"zuploader.low.quality.skip": "alles überspringen",
	"zuploader.download.title": "Herunterladen",
	"zuploader.download.count": "total $value Fotos",
	"zuploader.download.index": "Das $value Foto",
	"zuploader.power.by": "Macht durch"
};

var i18n = function () {
  function i18n() {
    this._local = enUS;
  }

  i18n.prototype.setLocal = function (local) {
    if (local === void 0) {
      local = 'en_US';
    }

    switch (local) {
      case 'en_GB':
        this._local = enGB;
        break;

      case 'es':
      case 'es_ES':
        this._local = esES;
        break;

      case 'de_DE':
        this._local = deDE;
        break;

      default:
        this._local = enUS;
    }
  };

  i18n.prototype.format = function (id, value) {
    if (value) return this._local[id].replace('$value', value);
    return this._local[id];
  };

  return i18n;
}();

var i18n$1 = new i18n();

var Icon = function Icon(_a) {
  var type = _a.type,
      color = _a.color,
      size = _a.size,
      className = _a.className;

  switch (type) {
    case 'close':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M15,12.8786797 L21.9393398,5.93933983 C22.5251263,5.35355339 23.4748737,5.35355339 24.0606602,5.93933983 C24.6464466,6.52512627 24.6464466,7.47487373 24.0606602,8.06066017 L17.1213203,15 L24.0606602,21.9393398 C24.6464466,22.5251263 24.6464466,23.4748737 24.0606602,24.0606602 C23.4748737,24.6464466 22.5251263,24.6464466 21.9393398,24.0606602 L15,17.1213203 L8.06066017,24.0606602 C7.47487373,24.6464466 6.52512627,24.6464466 5.93933983,24.0606602 C5.35355339,23.4748737 5.35355339,22.5251263 5.93933983,21.9393398 L12.8786797,15 L5.93933983,8.06066017 C5.35355339,7.47487373 5.35355339,6.52512627 5.93933983,5.93933983 C6.52512627,5.35355339 7.47487373,5.35355339 8.06066017,5.93933983 L15,12.8786797 Z"
      }));

    case 'down':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 20 20",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M4.70710678,6.79289322 L10,12.0857864 L15.2928932,6.79289322 C15.6834175,6.40236893 16.3165825,6.40236893 16.7071068,6.79289322 C17.0976311,7.18341751 17.0976311,7.81658249 16.7071068,8.20710678 L10.7071068,14.2071068 C10.3165825,14.5976311 9.68341751,14.5976311 9.29289322,14.2071068 L3.29289322,8.20710678 C2.90236893,7.81658249 2.90236893,7.18341751 3.29289322,6.79289322 C3.68341751,6.40236893 4.31658249,6.40236893 4.70710678,6.79289322 Z"
      }));

    case 'left':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M6.29289322,14.2928932 L14.2928932,6.29289322 C14.6834175,5.90236893 15.3165825,5.90236893 15.7071068,6.29289322 C16.0976311,6.68341751 16.0976311,7.31658249 15.7071068,7.70710678 L9.414,14 L22.9393939,14 C23.5251505,14 24,14.4477153 24,15 C24,15.5522847 23.5251505,16 22.9393939,16 L9.414,16 L15.7071068,22.2928932 C16.0976311,22.6834175 16.0976311,23.3165825 15.7071068,23.7071068 C15.3165825,24.0976311 14.6834175,24.0976311 14.2928932,23.7071068 L6.29289322,15.7071068 C5.90236893,15.3165825 5.90236893,14.6834175 6.29289322,14.2928932 Z"
      }));

    case 'album':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M12.2908253,14.0142199 L17.66,18.2328549 L16,21 L20.5857864,16.4142136 C21.366835,15.633165 22.633165,15.633165 23.4142136,16.4142136 L26,18.9998549 L26,21 C26,22.6568542 24.6568542,24 23,24 L7,24 C5.34314575,24 4,22.6568542 4,21 L4,19 L9.75359944,14.0683433 C10.478128,13.4473189 11.5404728,13.4246572 12.2908253,14.0142199 Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M23,6 C24.6568542,6 26,7.34314575 26,9 L26,17 L23.4142136,14.4142136 C22.6742728,13.6742728 21.4987886,13.6353285 20.7130012,14.2973808 L20.5857864,14.4142136 L18.2894897,16.7105103 L17.66,16.2328549 L12.2908253,12.0142199 C11.5873698,11.4615049 10.6097024,11.4468777 9.89324868,11.9589167 L9.75359944,12.0683433 L4,17 L4,9 C4,7.34314575 5.34314575,6 7,6 L23,6 Z M19.3235343,8.67688204 L19.3693019,8.78734891 C19.4537484,9.00872559 19.5,9.24896148 19.5,9.5 C19.5,10.6045695 18.6045695,11.5 17.5,11.5 C17.206478,11.5 16.9277244,11.4367694 16.676882,11.3235343 C16.990763,12.0173023 17.6890114,12.5 18.5,12.5 C19.6045695,12.5 20.5,11.6045695 20.5,10.5 C20.5,9.68901143 20.0173023,8.99076295 19.3235343,8.67688204 L19.3235343,8.67688204 Z",
        fillOpacity: "0.3"
      }));

    case 'camera':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M26,14.4996803 L26,21 C26,22.1045695 25.1045695,23 24,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,14.4996803 L10.1002017,14.4990961 C10.0344945,14.8224862 10,15.1572148 10,15.5 C10,18.2614237 12.2385763,20.5 15,20.5 C17.7614237,20.5 20,18.2614237 20,15.5 C20,15.1572148 19.9655055,14.8224862 19.8997983,14.4990961 L26,14.4996803 Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M17.1715729,6 C17.7020059,6 18.2107137,6.21071368 18.5857864,6.58578644 L20,8 L24,8 C25.1045695,8 26,8.8954305 26,10 L26,13 L19.3309172,12.9997031 C18.4663514,11.5053634 16.8505833,10.5 15,10.5 C13.1494167,10.5 11.5336486,11.5053634 10.6690828,12.9997031 L4,13 L4,10 C4,8.8954305 4.8954305,8 6,8 L10,8 L11.4142136,6.58578644 C11.7892863,6.21071368 12.2979941,6 12.8284271,6 L17.1715729,6 Z M21.5,10 L20.5,10 C20.2238576,10 20,10.2238576 20,10.5 C20,10.7454599 20.1768752,10.9496084 20.4101244,10.9919443 L20.5,11 L21.5,11 C21.7761424,11 22,10.7761424 22,10.5 C22,10.2545401 21.8231248,10.0503916 21.5898756,10.0080557 L21.5,10 Z",
        fillOpacity: "0.3"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "15",
        cy: "15.5",
        r: "3.5"
      }));

    case 'stock':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M22,5 C23.6568542,5 25,6.34314575 25,8 L25,16 C25,17.4866011 23.918707,18.7206526 22.4997053,18.9585702 L22.5,12 C22.5,9.51471863 20.4852814,7.5 18,7.5 L11.0414298,7.50029469 C11.2793474,6.08129303 12.5133989,5 14,5 L22,5 Z",
        fillOpacity: "0.3"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M18,9 C19.6568542,9 21,10.3431458 21,12 L21,22 C21,23.6568542 19.6568542,25 18,25 L8,25 C6.34314575,25 5,23.6568542 5,22 L5,12 C5,10.3431458 6.34314575,9 8,9 L18,9 Z M13.0000397,12.5 C12.7274907,12.6417903 12.5062791,12.8296549 12.3363048,13.0636045 C11.7491874,13.8717022 11.6240218,14.8744945 11.9109063,15.7569161 C11.1622856,15.210094 10.1698222,15.0192051 9.21977947,15.3278927 C8.94491829,15.4172005 8.69802029,15.5694042 8.47908548,15.7845037 C8.52914071,16.0875231 8.63949058,16.3561898 8.80959326,16.590316 C9.39648521,17.3981035 10.3110419,17.8270038 11.2385609,17.827173 C10.4880249,18.3705557 10,19.2552913 10,20.2540112 C10,20.543227 10.068558,20.8252737 10.2056739,21.1001514 L10.2089601,21.1005965 C10.5115287,21.1453962 10.7998359,21.1232746 11.0738814,21.0342318 C12.0230183,20.7258385 12.7133248,19.9891631 13.0003647,19.1076776 C13.2868007,19.989297 13.977068,20.7258666 14.9261186,21.0342318 C15.2013582,21.1236626 15.490984,21.1455877 15.7949959,21.1000071 C15.9316106,20.8245799 16,20.5428713 16,20.2540112 C16,19.2552366 15.5119216,18.3704587 14.7612664,17.8251792 C15.6885171,17.8272106 16.6033733,17.3982982 17.1904067,16.590316 C17.3603261,16.3564421 17.4706214,16.088102 17.5212926,15.785296 C17.3027123,15.5698559 17.0554895,15.417333 16.7802205,15.3278927 C15.8301778,15.0192051 14.8377144,15.210094 14.0871149,15.7557091 C14.3759782,14.8744945 14.2508126,13.8717022 13.6636952,13.0636045 C13.4937165,12.8296489 13.272498,12.6417807 13.0000397,12.5 Z"
      }));

    case 'cloud':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M17,7 C19.8503631,7 22.2365017,8.98758135 22.8480652,11.6523934 C22.4144238,11.5525211 21.9633454,11.5 21.5,11.5 C18.1862915,11.5 15.5,14.1862915 15.5,17.5 C15.5,19.2925116 16.2860469,20.9014321 17.5322495,22.0008701 L7.5,22 C5.56700338,22 4,20.4329966 4,18.5 C4,16.7228902 5.32445212,15.2551228 7.04011031,15.0299438 C7.01366083,14.8577739 7,14.6804823 7,14.5 C7,12.5670034 8.56700338,11 10.5,11 C10.7788527,11 11.0500887,11.0326105 11.3101026,11.0942259 C12.1046014,8.71541664 14.3519722,7 17,7 Z"
      }), /*#__PURE__*/React.createElement("circle", {
        fillOpacity: "0.3",
        cx: "21.5",
        cy: "17.5",
        r: "4.5"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "21.5",
        cy: "17.5",
        r: "2.5"
      }));

    case 'warning':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("circle", {
        fillOpacity: "0.3",
        cx: "15",
        cy: "15",
        r: "11"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M15,4 C21.0751322,4 26,8.92486775 26,15 C26,21.0751322 21.0751322,26 15,26 C8.92486775,26 4,21.0751322 4,15 C4,8.92486775 8.92486775,4 15,4 Z M15,5.5 C9.75329488,5.5 5.5,9.75329488 5.5,15 C5.5,20.2467051 9.75329488,24.5 15,24.5 C20.2467051,24.5 24.5,20.2467051 24.5,15 C24.5,9.75329488 20.2467051,5.5 15,5.5 Z M16,13.5 L16,19.5 L17,19.5 L17,20.5 L13,20.5 L13,19.5 L14,19.5 L14,14.5 L13,14.5 L13,13.5 L16,13.5 Z M15,9.5 C15.8284271,9.5 16.5,10.1715729 16.5,11 C16.5,11.8284271 15.8284271,12.5 15,12.5 C14.1715729,12.5 13.5,11.8284271 13.5,11 C13.5,10.1715729 14.1715729,9.5 15,9.5 Z"
      }));

    case 'add':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M15,6 C15.8284271,6 16.5,6.67157288 16.5,7.5 L16.5,13.499 L22.5,13.5 C23.3284271,13.5 24,14.1715729 24,15 C24,15.8284271 23.3284271,16.5 22.5,16.5 L16.5,16.5 L16.5,22.5 C16.5,23.3284271 15.8284271,24 15,24 C14.1715729,24 13.5,23.3284271 13.5,22.5 L13.5,16.5 L7.5,16.5 C6.67157288,16.5 6,15.8284271 6,15 C6,14.1715729 6.67157288,13.5 7.5,13.5 L13.5,13.5 L13.5,7.5 C13.5,6.67157288 14.1715729,6 15,6 Z"
      }));

    case 'close-circle':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("circle", {
        fillOpacity: "0.3",
        cx: "15",
        cy: "15",
        r: "11"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M15,4 C21.0751322,4 26,8.92486775 26,15 C26,21.0751322 21.0751322,26 15,26 C8.92486775,26 4,21.0751322 4,15 C4,8.92486775 8.92486775,4 15,4 Z M15,5.5 C9.75329488,5.5 5.5,9.75329488 5.5,15 C5.5,20.2467051 9.75329488,24.5 15,24.5 C20.2467051,24.5 24.5,20.2467051 24.5,15 C24.5,9.75329488 20.2467051,5.5 15,5.5 Z M11.4462117,10.3970518 L11.5303301,10.4696699 L15,13.939 L18.4696699,10.4696699 C18.7625631,10.1767767 19.2374369,10.1767767 19.5303301,10.4696699 C19.7965966,10.7359365 19.8208027,11.1526002 19.6029482,11.4462117 L19.5303301,11.5303301 L16.061,15 L19.5303301,18.4696699 C19.8232233,18.7625631 19.8232233,19.2374369 19.5303301,19.5303301 C19.2640635,19.7965966 18.8473998,19.8208027 18.5537883,19.6029482 L18.4696699,19.5303301 L15,16.061 L11.5303301,19.5303301 C11.2374369,19.8232233 10.7625631,19.8232233 10.4696699,19.5303301 C10.2034034,19.2640635 10.1791973,18.8473998 10.3970518,18.5537883 L10.4696699,18.4696699 L13.939,15 L10.4696699,11.5303301 C10.1767767,11.2374369 10.1767767,10.7625631 10.4696699,10.4696699 C10.7359365,10.2034034 11.1526002,10.1791973 11.4462117,10.3970518 Z"
      }));

    case 'search':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M14,4.5 C19.2467051,4.5 23.5,8.75329488 23.5,14 C23.5,16.2629097 22.7087994,18.3410246 21.3879416,19.9728012 L24.863961,23.4497475 C25.2544853,23.8402718 25.2544853,24.4734367 24.863961,24.863961 C24.4734367,25.2544853 23.8402718,25.2544853 23.4497475,24.863961 L19.9728012,21.3879416 C18.3410246,22.7087994 16.2629097,23.5 14,23.5 C8.75329488,23.5 4.5,19.2467051 4.5,14 C4.5,8.75329488 8.75329488,4.5 14,4.5 Z M14,6.5 C9.85786438,6.5 6.5,9.85786438 6.5,14 C6.5,18.1421356 9.85786438,21.5 14,21.5 C18.1421356,21.5 21.5,18.1421356 21.5,14 C21.5,9.85786438 18.1421356,6.5 14,6.5 Z"
      }));

    case 'confirm':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M12.9548855,18.8335652 L23.3961035,7.4844152 C23.9569955,6.87474999 24.9059196,6.83521149 25.5155848,7.39610348 C26.12525,7.95699548 26.1647885,8.90591958 25.6038965,9.5155848 L14.1038965,22.0155848 C13.5264165,22.6432805 12.5424505,22.6637709 11.9393398,22.0606602 L4.43933983,14.5606602 C3.85355339,13.9748737 3.85355339,13.0251263 4.43933983,12.4393398 C5.02512627,11.8535534 5.97487373,11.8535534 6.56066017,12.4393398 L12.9548855,18.8335652 Z"
      }));

    case 'confirm-circle':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("circle", {
        fillOpacity: "0.3",
        strokeWidth: "2",
        cx: "15",
        cy: "15",
        r: "10"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M19.2928932,11.2928932 C19.6834175,10.9023689 20.3165825,10.9023689 20.7071068,11.2928932 C21.0675907,11.6533772 21.0953203,12.2206082 20.7902954,12.6128994 L20.7071068,12.7071068 L13.7071068,19.7071068 C13.3157663,20.0984473 12.6892372,20.093248 12.3036252,19.717878 L12.2191312,19.624695 L8.21913119,14.624695 C7.87412164,14.1934331 7.94404302,13.5641407 8.37530495,13.2191312 C8.77339289,12.9006608 9.34021683,12.9357411 9.69642431,13.2822217 L9.78086881,13.375305 L13.082,17.502 L19.2928932,11.2928932 Z"
      }));

    case 'up':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M14.9999936,12.2422642 L7.11493477,21.0034406 C6.56074624,21.6192057 5.61231149,21.6691233 4.99654645,21.1149348 C4.38078142,20.5607462 4.3308638,19.6123115 4.88505233,18.9965465 L13.8850523,8.99654645 C14.4809158,8.33447592 15.5190713,8.33447592 16.1149348,8.99654645 L25.1149348,18.9965465 C25.6691233,19.6123115 25.6192057,20.5607462 25.0034406,21.1149348 C24.3876756,21.6691233 23.4392409,21.6192057 22.8850523,21.0034406 L14.9999936,12.2422642 Z"
      }));

    case 'rotate-left':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M9.48528137,10.5137085 L11.3137085,10.5137085 C11.8659932,10.5137085 12.3137085,10.9614237 12.3137085,11.5137085 C12.3137085,12.0659932 11.8659932,12.5137085 11.3137085,12.5137085 L7.07106781,12.5137085 C6.51878306,12.5137085 6.07106781,12.0659932 6.07106781,11.5137085 L6.07106781,7.27106781 C6.07106781,6.71878306 6.51878306,6.27106781 7.07106781,6.27106781 C7.62335256,6.27106781 8.07106781,6.71878306 8.07106781,7.27106781 L8.07106781,9.09949494 L8.48528137,8.68528137 C12,5.17056275 17.6984848,5.17056275 21.2132034,8.68528137 C24.7279221,12.2 24.7279221,17.8984848 21.2132034,21.4132034 C17.6984848,24.9279221 12,24.9279221 8.48528137,21.4132034 C8.09475708,21.0226791 8.09475708,20.3895142 8.48528137,19.9989899 C8.87580567,19.6084656 9.50897064,19.6084656 9.89949494,19.9989899 C12.633165,22.7326599 17.0653198,22.7326599 19.7989899,19.9989899 C22.5326599,17.2653198 22.5326599,12.833165 19.7989899,10.0994949 C17.0653198,7.36582489 12.633165,7.36582489 9.89949494,10.0994949 L9.48528137,10.5137085 Z"
      }));

    case 'rotate-right':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M20.513961,10.5137085 L20.0997475,10.0994949 C17.3660774,7.36582489 12.9339226,7.36582489 10.2002525,10.0994949 C7.46658249,12.833165 7.46658249,17.2653198 10.2002525,19.9989899 C12.9339226,22.7326599 17.3660774,22.7326599 20.0997475,19.9989899 C20.4902718,19.6084656 21.1234367,19.6084656 21.513961,19.9989899 C21.9044853,20.3895142 21.9044853,21.0226791 21.513961,21.4132034 C17.9992424,24.9279221 12.3007576,24.9279221 8.78603897,21.4132034 C5.27132034,17.8984848 5.27132034,12.2 8.78603897,8.68528137 C12.3007576,5.17056275 17.9992424,5.17056275 21.513961,8.68528137 L21.9281746,9.09949494 L21.9281746,7.27106781 C21.9281746,6.71878306 22.3758898,6.27106781 22.9281746,6.27106781 C23.4804593,6.27106781 23.9281746,6.71878306 23.9281746,7.27106781 L23.9281746,11.5137085 C23.9281746,12.0659932 23.4804593,12.5137085 22.9281746,12.5137085 L18.6855339,12.5137085 C18.1332492,12.5137085 17.6855339,12.0659932 17.6855339,11.5137085 C17.6855339,10.9614237 18.1332492,10.5137085 18.6855339,10.5137085 L20.513961,10.5137085 Z"
      }));

    case 'crop':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M26,20 L26,22 L22,22 L22,26 L20,26 L20,22 L11,22 C9.40231912,22 8.09633912,20.75108 8.00509269,19.1762728 L8,19 L8,10 L4,10 L4,8 L8,8 L8,4 L10,4 L10,19 C10,19.5128358 10.3860402,19.9355072 10.8833789,19.9932723 L11,20 L26,20 Z M19,8 C20.5976809,8 21.9036609,9.24891996 21.9949073,10.8237272 L22,11 L22,18 L20,18 L20,11 C20,10.4871642 19.6139598,10.0644928 19.1166211,10.0067277 L19,10 L12,10 L12,8 L19,8 Z"
      }));

    case 'delete':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M22,10 L22,24 C22,25.0543618 21.1841222,25.9181651 20.1492623,25.9945143 L20,26 L10,26 C8.9456382,26 8.08183488,25.1841222 8.00548574,24.1492623 L8,24 L8,10 L22,10 Z M20,12 L10,12 L10,24 L20,24 L20,12 Z M13,14 C13.5522847,14 14,14.4477153 14,15 L14,21 C14,21.5522847 13.5522847,22 13,22 C12.4477153,22 12,21.5522847 12,21 L12,15 C12,14.4477153 12.4477153,14 13,14 Z M17,14 C17.5522847,14 18,14.4477153 18,15 L18,21 C18,21.5522847 17.5522847,22 17,22 C16.4477153,22 16,21.5522847 16,21 L16,15 C16,14.4477153 16.4477153,14 17,14 Z M17,3 C18.0543618,3 18.9181651,3.81587779 18.9945143,4.85073766 L19,5 L19,7 L23,7 C23.5522847,7 24,7.44771525 24,8 C24,8.55228475 23.5522847,9 23,9 L7,9 C6.44771525,9 6,8.55228475 6,8 C6,7.44771525 6.44771525,7 7,7 L11,7 L11,5 C11,3.9456382 11.8158778,3.08183488 12.8507377,3.00548574 L13,3 L17,3 Z M17,5 L13,5 L13,7 L17,7 L17,5 Z"
      }));

    case 'reset':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M23,14 C23.5522847,14 24,14.4477153 24,15 C24,19.9705627 19.9705627,24 15,24 C12.5515523,24 10.2783816,23.0132773 8.62463825,21.3539753 L8.61421356,21.363961 L8.2,20.9497475 L8.2,22.7781746 C8.2,23.3304593 7.75228475,23.7781746 7.2,23.7781746 C6.64771525,23.7781746 6.2,23.3304593 6.2,22.7781746 L6.2,18.5355339 C6.2,17.9832492 6.64771525,17.5355339 7.2,17.5355339 L11.4426407,17.5355339 C11.9949254,17.5355339 12.4426407,17.9832492 12.4426407,18.5355339 C12.4426407,19.0878187 11.9949254,19.5355339 11.4426407,19.5355339 L9.66704985,19.5358841 C10.9724273,21.0703415 12.9032477,22 15,22 C18.8659932,22 22,18.8659932 22,15 C22,14.4477153 22.4477153,14 23,14 Z M15,6 C17.6160893,6 20.0353171,7.12624107 21.7120244,9.00294784 L21.7781746,9.07025253 L21.7781746,7.24182541 C21.7781746,6.68954066 22.2258898,6.24182541 22.7781746,6.24182541 C23.3304593,6.24182541 23.7781746,6.68954066 23.7781746,7.24182541 L23.7781746,11.4844661 C23.7781746,12.0367508 23.3304593,12.4844661 22.7781746,12.4844661 L18.5355339,12.4844661 C17.9832492,12.4844661 17.5355339,12.0367508 17.5355339,11.4844661 C17.5355339,10.9321813 17.9832492,10.4844661 18.5355339,10.4844661 L20.3501262,10.4846401 C20.3183573,10.4469993 20.2862159,10.409721 20.2537085,10.3728098 L19.9497475,10.0702525 L19.9603715,10.059593 C18.6722259,8.76585703 16.9035172,8 15,8 C11.1340068,8 8,11.1340068 8,15 C8,15.5522847 7.55228475,16 7,16 C6.44771525,16 6,15.5522847 6,15 C6,10.0294373 10.0294373,6 15,6 Z"
      }));

    case 'zoom-in':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M14,4.5 C19.2467051,4.5 23.5,8.75329488 23.5,14 C23.5,16.2629097 22.7087994,18.3410246 21.3879416,19.9728012 L24.863961,23.4497475 C25.2544853,23.8402718 25.2544853,24.4734367 24.863961,24.863961 C24.4734367,25.2544853 23.8402718,25.2544853 23.4497475,24.863961 L19.9728012,21.3879416 C18.3410246,22.7087994 16.2629097,23.5 14,23.5 C8.75329488,23.5 4.5,19.2467051 4.5,14 C4.5,8.75329488 8.75329488,4.5 14,4.5 Z M14,6.5 C9.85786438,6.5 6.5,9.85786438 6.5,14 C6.5,18.1421356 9.85786438,21.5 14,21.5 C18.1421356,21.5 21.5,18.1421356 21.5,14 C21.5,9.85786438 18.1421356,6.5 14,6.5 Z M14,9.5 C14.5522847,9.5 15,9.94771525 15,10.5 L15,13 L17.5,13 C18.0522847,13 18.5,13.4477153 18.5,14 C18.5,14.5522847 18.0522847,15 17.5,15 L15,15 L15,17.5 C15,18.0522847 14.5522847,18.5 14,18.5 C13.4477153,18.5 13,18.0522847 13,17.5 L13,15 L10.5,15 C9.94771525,15 9.5,14.5522847 9.5,14 C9.5,13.4477153 9.94771525,13 10.5,13 L13,13 L13,10.5 C13,9.94771525 13.4477153,9.5 14,9.5 Z"
      }));

    case 'zoom-out':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        },
        fill: color
      }, /*#__PURE__*/React.createElement("path", {
        d: "M14,4.5 C19.2467051,4.5 23.5,8.75329488 23.5,14 C23.5,16.2629097 22.7087994,18.3410246 21.3879416,19.9728012 L24.863961,23.4497475 C25.2544853,23.8402718 25.2544853,24.4734367 24.863961,24.863961 C24.4734367,25.2544853 23.8402718,25.2544853 23.4497475,24.863961 L19.9728012,21.3879416 C18.3410246,22.7087994 16.2629097,23.5 14,23.5 C8.75329488,23.5 4.5,19.2467051 4.5,14 C4.5,8.75329488 8.75329488,4.5 14,4.5 Z M14,6.5 C9.85786438,6.5 6.5,9.85786438 6.5,14 C6.5,18.1421356 9.85786438,21.5 14,21.5 C18.1421356,21.5 21.5,18.1421356 21.5,14 C21.5,9.85786438 18.1421356,6.5 14,6.5 Z M15,13 L17.5,13 C18.0522847,13 18.5,13.4477153 18.5,14 C18.5,14.5522847 18.0522847,15 17.5,15 L15,15 L13,15 L10.5,15 C9.94771525,15 9.5,14.5522847 9.5,14 C9.5,13.4477153 9.94771525,13 10.5,13 L13,13 L15,13 Z"
      }));

    case 'facebook':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 20 20",
        style: {
          width: size,
          height: size
        },
        fill: "#3a559f"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M0,0 L0,19.9881579 L10.6449123,19.9881579 L10.6449123,12.2671491 L8.0427193,12.2671491 L8.0427193,9.1152193 L10.6449123,9.1152193 L10.6449123,6.46815789 C10.6449123,4.54302632 12.2055263,2.98241228 14.1306579,2.98241228 L16.8510526,2.98241228 L16.8510526,5.81671053 L14.9044737,5.81671053 C14.2927632,5.81671053 13.7968421,6.31263158 13.7968421,6.92434211 L13.7968421,9.11526316 L16.8021491,9.11526316 L16.3867982,12.267193 L13.7968421,12.267193 L13.7968421,19.9881579 L19.9881579,19.9881579 L19.9881579,0 L0,0 Z"
      }));

    case 'instagram':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 20 20",
        style: {
          width: size,
          height: size
        }
      }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
        x1: "6.71416922%",
        y1: "93.4850191%",
        x2: "93.6081727%",
        y2: "6.61873642%",
        id: "linearGradient"
      }, /*#__PURE__*/React.createElement("stop", {
        stopColor: "#FFDD55",
        offset: "0%"
      }), /*#__PURE__*/React.createElement("stop", {
        stopColor: "#FF543E",
        offset: "50%"
      }), /*#__PURE__*/React.createElement("stop", {
        stopColor: "#C837AB",
        offset: "100%"
      }))), /*#__PURE__*/React.createElement("g", {
        transform: "translate(-157.000000, -13.000000)",
        fill: "url(#linearGradient)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(127.500000, 13.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(30.000000, 0.000000)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M1.30459402,1.38853951 C2.91575695,-0.281700506 4.69986957,0.0129405025 12.4412887,0.0310898193 L13.2784278,0.0318822438 C15.6615614,0.036036124 15.7546266,0.0559747488 16.2191216,0.123267607 C18.2457823,0.414869995 19.7838507,1.85460486 19.9799524,4.35274839 C20.0065424,4.68672036 20.0065424,15.3131766 19.9807833,15.6405024 C19.7963148,17.9857831 18.4468695,19.3308095 16.7883149,19.7586592 C15.5460608,20.0801695 4.52448339,20.0801695 3.28056742,19.7603207 C-0.702955065,18.7309892 0.058185235,14.3586149 0.058185235,9.99704077 C0.058185235,4.74487468 -0.262557293,3.01602976 1.30459402,1.38853951 Z M10.3441115,2.6390034 L10.0277937,2.63968821 C7.01065345,2.63968821 4.14557512,2.37134755 3.0512282,5.17937055 C2.62578734,6.27091252 2.6589099,7.66932993 2.66427878,9.62812294 L2.66484148,10.0020254 C2.66484148,11.8945332 2.60418292,13.6732247 3.0512282,14.8238495 C4.11357273,17.5575966 6.87661246,17.3766635 9.78358431,17.3648864 L10.0261318,17.3643626 C12.9153073,17.3643626 15.8942243,17.6651036 17.0018663,14.8238495 C17.4280892,13.7213609 17.3942766,12.3421692 17.3888238,10.3773644 L17.388253,10.0020254 C17.388253,7.12587879 17.5469624,5.26909436 16.1518155,3.87505217 C14.7935495,2.51705289 12.9751018,2.62842726 10.3441115,2.6390034 Z M16.0205271,12.9745421 C15.8668937,16.3367469 13.3586609,16.0488865 10.2375851,16.0347819 L10.0286246,16.0342902 C4.25244668,16.0342902 4.000052,15.8715973 3.99365315,10.2654954 L3.99351325,9.99870232 C3.99351325,4.06280756 4.45883919,3.96976064 9.36802794,3.96477599 L9.36802794,3.96643754 C15.6615614,3.95646823 16.4625868,3.25695481 16.0205271,12.9745421 Z M10.0277937,6.22116369 C7.93964347,6.22116369 6.24702033,7.91428525 6.24702033,10.0020254 C6.24702033,12.0897656 7.93964347,13.7820564 10.0277937,13.7820564 C12.1159438,13.7820564 13.807736,12.0897656 13.807736,10.0020254 C13.807736,7.91428525 12.1159438,6.22116369 10.0277937,6.22116369 Z M10.0277937,7.54791302 C13.2726112,7.54791302 13.2767659,12.4561378 10.0277937,12.4561378 C6.78380705,12.4561378 6.77882142,7.54791302 10.0277937,7.54791302 Z M13.958136,5.18850908 C13.4703747,5.18850908 13.0748477,5.58395848 13.0748477,6.07162401 C13.0748477,6.55928954 13.4703747,6.95473893 13.958136,6.95473893 C14.4458973,6.95473893 14.8414244,6.55928954 14.8414244,6.07162401 C14.8414244,5.58395848 14.4458973,5.18850908 13.958136,5.18850908 Z"
      })))));

    case 'google-driver':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 21 18",
        style: {
          width: size,
          height: size
        }
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(-187.000000, -14.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(127.500000, 13.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(60.000000, 0.000000)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(0.000000, 1.049479)"
      }, /*#__PURE__*/React.createElement("g", {
        transform: "translate(0.000000, 0.117187)",
        fill: "#59C36A"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M9.97636719,5.02527344 L5.82796875,12.2205859 L5.81625,12.2205859 L8.21859375,15.1502734 L2.82800781,17.4119922 C2.7225,17.3533984 2.64046875,17.2713672 2.59363281,17.1893359 L0.06234375,12.5018359 C-0.0665625,12.2439844 0.0389453125,12.0448047 0.0740625,11.9276172 L6.85925781,0.208867187 C6.90609375,0.138554687 6.97640625,0.0682421875 7.07019531,0.009609375 L7.08191406,0.009609375 L10.5623438,1.08777344 L9.97636719,5.02527344 Z"
      })), /*#__PURE__*/React.createElement("path", {
        d: "M19.988125,12.3378125 L15.2889063,15.2675 L14.175625,12.3378125 L9.97640625,5.1425 L7.081875,0.126796875 C7.16382813,0.068203125 7.26933594,0.0330859375 7.363125,0.0330859375 L12.6287109,0.0330859375 C12.7459375,0.068203125 12.9803125,0.056484375 13.1326172,0.326054688 L19.9178125,12.0448047 C19.9646484,12.126875 19.988125,12.2323047 19.988125,12.3378125 Z",
        fill: "#FFDA2D"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M13.1325781,0.32609375 C12.9803125,0.0565234375 12.7458984,0.0682421875 12.6286719,0.033125 L9.97636719,0.033125 L9.97636719,5.1425 L14.1755859,12.3378125 L15.2888672,15.2675 L19.9880859,12.3378125 C19.9880859,12.2323047 19.9646094,12.126875 19.9177734,12.0448437 L13.1325781,0.32609375 Z",
        fill: "#FDBF00"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M19.988125,12.3378125 C19.988125,12.4432422 19.9646484,12.54875 19.9295313,12.6190625 L17.3982422,17.3065625 C17.3044531,17.4589062 17.081875,17.61125 16.8826172,17.61125 L3.10921875,17.61125 C3.01542969,17.61125 2.90996094,17.5760547 2.82796875,17.5292187 L5.81625,12.3378125 L19.988125,12.3378125 Z",
        fill: "#4086F4"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M9.97636719,17.61125 L16.8826172,17.61125 C17.081875,17.61125 17.3044922,17.4589062 17.3982422,17.3065625 L19.9295312,12.6190625 C19.9646484,12.54875 19.988125,12.4432422 19.988125,12.3378125 L9.97636719,12.3378125 L9.97636719,17.61125 L9.97636719,17.61125 Z",
        fill: "#4175DF"
      }))))));

    case 'pexels':
      return /*#__PURE__*/React.createElement("svg", {
        className: className,
        viewBox: "0 0 30 30",
        style: {
          width: size,
          height: size
        }
      }, /*#__PURE__*/React.createElement("path", {
        d: "M5.375,4 L24.625,4 C25.3843915,4 26,4.61560847 26,5.375 L26,24.625 C26,25.3843915 25.3843915,26 24.625,26 L5.375,26 C4.61560847,26 4,25.3843915 4,24.625 L4,5.375 C4,4.61560847 4.61560847,4 5.375,4 Z",
        fill: "#05a081"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12.9375,18.4375 L15.5933125,18.4375 L15.5933125,15.858 L16.395625,15.858 C17.5817946,15.858 18.543375,14.8964196 18.543375,13.71025 C18.543375,12.5240804 17.5817946,11.5625 16.395625,11.5625 L12.9375,11.5625 L12.9375,18.4375 Z M16.9683125,19.8125 L11.5625,19.8125 L11.5625,10.1874999 L16.395625,10.1874999 C18.2300532,10.1871452 19.7577156,11.5946361 19.9073216,13.4229537 C20.0569275,15.2512712 18.7783963,16.8883849 16.9683125,17.18625 L16.9683125,19.8125 Z",
        fill: "#fff"
      }));

    default:
      return null;
  }
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$b = ".index-module_header__2KzaW {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 100%;\n  height: 60px;\n  border-bottom: 1px solid rgba(0, 0, 0, .14);\n}\n.index-module_header__2KzaW .index-module_iconWrapper__v7_Dg {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100%;\n  padding: 0 12px;\n  cursor: pointer;\n}\n.index-module_header__2KzaW .index-module_iconWrapper__v7_Dg.index-module_iconWrapperHide__2vGDU {\n  cursor: none;\n  opacity: 0;\n  pointer-events: none;\n}\n.index-module_headerContent__1NveK {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 0 50px;\n  pointer-events: none;\n}\n.index-module_headerContent__1NveK .index-module_title__2pP3f {\n  padding: 2px;\n  color: #000;\n  font-weight: 700;\n  font-size: 16px;\n  text-transform: capitalize;\n}\n";
var styles$b = {"header":"index-module_header__2KzaW","iconWrapper":"index-module_iconWrapper__v7_Dg","iconWrapperHide":"index-module_iconWrapperHide__2vGDU","headerContent":"index-module_headerContent__1NveK","title":"index-module_title__2pP3f"};
styleInject(css_248z$b);

var Header = function Header(_a) {
  var _b;

  var className = _a.className,
      title = _a.title,
      contentClassName = _a.contentClassName,
      _c = _a.closable,
      closable = _c === void 0 ? true : _c,
      onClose = _a.onClose,
      _d = _a.closeIconType,
      closeIconType = _d === void 0 ? 'close' : _d,
      renderExtra = _a.renderExtra,
      renderTitleExtra = _a.renderTitleExtra;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$b.header, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$b.iconWrapper, (_b = {}, _b[styles$b.iconWrapperHide] = !closable, _b)),
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    type: closeIconType,
    size: 30
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$b.headerContent, contentClassName)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$b.title
  }, title), renderTitleExtra), renderExtra);
};

var css_248z$a = ".zuploader-list {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.zuploader-list .list-module_content__1HCfD {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n  -webkit-align-content: flex-start;\n      -ms-flex-line-pack: start;\n          align-content: flex-start;\n  padding: 10px 5px;\n  overflow-y: auto;\n}\n.zuploader-list .list-module_content__1HCfD .list-module_imageWrapper__1gfVR {\n  position: relative;\n  width: 25%;\n  padding: 0 5px 10px;\n}\n@media screen and (min-width: 768px) {\n  .zuploader-list .list-module_content__1HCfD .list-module_imageWrapper__1gfVR {\n    width: 16.66667%;\n  }\n}\n";
var styles$a = {"content":"list-module_content__1HCfD","imageWrapper":"list-module_imageWrapper__1gfVR"};
styleInject(css_248z$a);

var ZuploaderList = function ZuploaderList(_a) {
  var images = _a.images,
      renderImageContent = _a.renderImageContent,
      renderHeader = _a.renderHeader,
      renderFooter = _a.renderFooter;
  return /*#__PURE__*/React.createElement("div", {
    className: "zuploader-list"
  }, renderHeader, /*#__PURE__*/React.createElement("div", {
    className: styles$a.content
  }, images.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles$a.imageWrapper
    }, renderImageContent(item));
  })), renderFooter);
};

var css_248z$9 = ".index-module_drawer__3Z5CA {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n}\n.index-module_drawerMask__3s3se {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, .7);\n  -webkit-animation: index-module_drawer-mask__27nWm 0.3s linear;\n          animation: index-module_drawer-mask__27nWm 0.3s linear;\n}\n.index-module_drawerMask__3s3se.index-module_drawerMaskHide__1BA4f {\n  display: none;\n}\n.index-module_drawerContent__1kRTz {\n  position: absolute;\n}\n.index-module_drawerBottom__1uPw3 .index-module_drawerContent__1kRTz {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  -webkit-animation: index-module_drawer-bottom__1_xq5 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n          animation: index-module_drawer-bottom__1_xq5 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.index-module_drawerTop__3Jenu .index-module_drawerContent__1kRTz {\n  top: 0;\n  left: 0;\n  width: 100%;\n  -webkit-animation: index-module_drawer-top__2htQB 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n          animation: index-module_drawer-top__2htQB 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n@-webkit-keyframes index-module_drawer-bottom__1_xq5 {\n  from {\n    -webkit-transform: translate(0, 100%);\n            transform: translate(0, 100%);\n  }\n  to {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0);\n  }\n}\n@keyframes index-module_drawer-bottom__1_xq5 {\n  from {\n    -webkit-transform: translate(0, 100%);\n            transform: translate(0, 100%);\n  }\n  to {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0);\n  }\n}\n@-webkit-keyframes index-module_drawer-top__2htQB {\n  from {\n    -webkit-transform: translate(0, -100%);\n            transform: translate(0, -100%);\n  }\n  to {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0);\n  }\n}\n@keyframes index-module_drawer-top__2htQB {\n  from {\n    -webkit-transform: translate(0, -100%);\n            transform: translate(0, -100%);\n  }\n  to {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0);\n  }\n}\n@-webkit-keyframes index-module_drawer-mask__27nWm {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes index-module_drawer-mask__27nWm {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n";
var styles$9 = {"drawer":"index-module_drawer__3Z5CA","drawerMask":"index-module_drawerMask__3s3se","drawer-mask":"index-module_drawer-mask__27nWm","drawerMaskHide":"index-module_drawerMaskHide__1BA4f","drawerContent":"index-module_drawerContent__1kRTz","drawerBottom":"index-module_drawerBottom__1uPw3","drawer-bottom":"index-module_drawer-bottom__1_xq5","drawerTop":"index-module_drawerTop__3Jenu","drawer-top":"index-module_drawer-top__2htQB"};
styleInject(css_248z$9);

var Drawer = function Drawer(_a) {
  var _b, _c;

  var className = _a.className,
      style = _a.style,
      _d = _a.mask,
      mask = _d === void 0 ? true : _d,
      _e = _a.duration,
      duration = _e === void 0 ? 0.3 : _e,
      _f = _a.position,
      position = _f === void 0 ? 'bottom' : _f,
      onClose = _a.onClose,
      children = _a.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$9.drawer, (_b = {}, _b[styles$9.drawerBottom] = position === 'bottom', _b[styles$9.drawerTop] = position === 'top', _b))
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$9.drawerMask, (_c = {}, _c[styles$9.drawerMaskHide] = mask === false, _c)),
    onClick: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$9.drawerContent, className),
    style: __assign(__assign({}, style), {
      animationDuration: duration + "s"
    })
  }, children));
};

var css_248z$8 = ".zuploader-download {\n  z-index: 2147483648;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  background: #fff;\n}\n.zuploader-download .download-module_image__2yvva {\n  position: relative;\n  width: 90px;\n  height: 90px;\n  background-color: #e4e7ed;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  -webkit-transition: background-image 0.2s;\n  -o-transition: background-image 0.2s;\n  transition: background-image 0.2s;\n}\n.zuploader-download .download-module_downloadContent__1ik-i {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.zuploader-download .download-module_downloadContent__1ik-i .download-module_title__3AG1p {\n  padding: 15px 0 0 15px;\n  font-size: 14px;\n}\n.zuploader-download .download-module_downloadContent__1ik-i .download-module_content__3LOgZ {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -webkit-box-align: end;\n  -webkit-align-items: flex-end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 5px 12px 5px 20px;\n}\n.zuploader-download .download-module_downloadContent__1ik-i .download-module_content__3LOgZ span {\n  color: #909399;\n  font-size: 12px;\n}\n.zuploader-download .download-module_downloadContent__1ik-i .download-module_content__3LOgZ .download-module_button__Mq9cv {\n  padding: 8px 16px;\n  color: #ff533a;\n  font-size: 16px;\n  text-transform: capitalize;\n  background: rgba(255, 83, 58, .1);\n  border-radius: 6px;\n  cursor: pointer;\n}\n.zuploader-download .download-module_downloadContent__1ik-i .download-module_progress__3i6na {\n  position: relative;\n  height: 5px;\n  background: #e4e7ed;\n}\n.zuploader-download .download-module_downloadContent__1ik-i .download-module_progressDone__1KlGe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background-color: #ff533a;\n  -webkit-transition: width 0.2s;\n  -o-transition: width 0.2s;\n  transition: width 0.2s;\n}\n";
var styles$8 = {"image":"download-module_image__2yvva","downloadContent":"download-module_downloadContent__1ik-i","title":"download-module_title__3AG1p","content":"download-module_content__3LOgZ","button":"download-module_button__Mq9cv","progress":"download-module_progress__3i6na","progressDone":"download-module_progressDone__1KlGe"};
styleInject(css_248z$8);

var ZuploaderDownload = function ZuploaderDownload(_a) {
  var _b;

  var images = _a.images,
      onCancel = _a.onCancel;
  var percent = images.map(function (_a) {
    var percent = _a.percent;
    return percent || 0;
  }).reduce(function (a, b) {
    return a + b;
  });
  var currentIndex = Math.max(Math.ceil(percent), 1);
  return /*#__PURE__*/React.createElement(Drawer, {
    className: "zuploader-download"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$8.image,
    style: {
      backgroundImage: "url(" + ((_b = images[currentIndex - 1]) === null || _b === void 0 ? void 0 : _b.url) + ")"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$8.downloadContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$8.title
  }, i18n$1.format('zuploader.download.title')), /*#__PURE__*/React.createElement("div", {
    className: styles$8.content
  }, /*#__PURE__*/React.createElement("span", null, i18n$1.format('zuploader.download.index', currentIndex), ",", ' ', i18n$1.format('zuploader.download.count', images.length)), /*#__PURE__*/React.createElement("div", {
    className: styles$8.button,
    onClick: onCancel
  }, "stop")), /*#__PURE__*/React.createElement("div", {
    className: styles$8.progress
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$8.progressDone,
    style: {
      width: percent / images.length * 100 + "%"
    }
  }))));
};

var css_248z$7 = ".index-module_loading__3oJmu {\n  width: 24px;\n  height: 24px;\n}\n.index-module_loading__3oJmu svg {\n  width: 100%;\n  height: 100%;\n  -webkit-animation: index-module_loading-rotate__1sH_9 2s linear infinite;\n          animation: index-module_loading-rotate__1sH_9 2s linear infinite;\n}\n.index-module_loading__3oJmu svg > circle {\n  -webkit-animation: index-module_loading-dash__gGquB 1.5s ease-in-out infinite;\n          animation: index-module_loading-dash__gGquB 1.5s ease-in-out infinite;\n  stroke-dasharray: 90, 150;\n  stroke-dashoffset: 0;\n  stroke: #909399;\n  stroke-width: 6;\n  stroke-linecap: round;\n}\n@-webkit-keyframes index-module_loading-rotate__1sH_9 {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes index-module_loading-rotate__1sH_9 {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes index-module_loading-dash__gGquB {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -40px;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -120px;\n  }\n}\n@keyframes index-module_loading-dash__gGquB {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -40px;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -120px;\n  }\n}\n";
var styles$7 = {"loading":"index-module_loading__3oJmu","loading-rotate":"index-module_loading-rotate__1sH_9","loading-dash":"index-module_loading-dash__gGquB"};
styleInject(css_248z$7);

var Loading = function Loading(_a) {
  var size = _a.size,
      color = _a.color;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$7.loading,
    style: {
      width: size,
      height: size
    }
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "25 25 50 50"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    stroke: color
  })));
};

var css_248z$6 = ".zuploader-low-quality {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background: #fff;\n}\n.zuploader-low-quality .low-quality-module_headerContent__1E8r4 > span {\n  color: #ff533a;\n}\n.zuploader-low-quality .low-quality-module_headerExtra__2hjBj {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 100%;\n  padding: 0 12px;\n}\n.zuploader-low-quality .low-quality-module_headerExtra__2hjBj .low-quality-module_skip__3A0D- {\n  padding: 4px 10px;\n  color: #ff533a;\n  font-size: 12px;\n  text-transform: capitalize;\n  background: rgba(255, 83, 58, .1);\n  border: 1px solid rgba(255, 83, 58, .2);\n  border-radius: 14px;\n}\n.zuploader-low-quality .low-quality-module_content__1YJr1 {\n  padding: 0 30px;\n}\n.zuploader-low-quality .low-quality-module_content__1YJr1 .low-quality-module_imageWrapper__3sEQu {\n  width: 100%;\n  padding: 20px 30px;\n}\n.zuploader-low-quality .low-quality-module_content__1YJr1 .low-quality-module_imageWrapper__3sEQu .low-quality-module_image__2R7Za {\n  width: 100%;\n  height: 150px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.zuploader-low-quality .low-quality-module_content__1YJr1 .low-quality-module_tips__cvOkY {\n  padding-bottom: 20px;\n  color: #606266;\n  font-weight: 700;\n  font-size: 14px;\n  text-align: center;\n  cursor: pointer;\n}\n.zuploader-low-quality .low-quality-module_content__1YJr1 .low-quality-module_button__1-61w {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n  height: 50px;\n  margin-bottom: 30px;\n  color: #000;\n  font-weight: 700;\n  font-size: 16px;\n  background: #f2f2f2;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.zuploader-low-quality .low-quality-module_content__1YJr1 .low-quality-module_button__1-61w.low-quality-module_buttonActive__1Meca {\n  margin-bottom: 12px;\n  color: #ff533a;\n  background: rgba(255, 83, 58, .1);\n}\n";
var styles$6 = {"headerContent":"low-quality-module_headerContent__1E8r4","headerExtra":"low-quality-module_headerExtra__2hjBj","skip":"low-quality-module_skip__3A0D-","content":"low-quality-module_content__1YJr1","imageWrapper":"low-quality-module_imageWrapper__3sEQu","image":"low-quality-module_image__2R7Za","tips":"low-quality-module_tips__cvOkY","button":"low-quality-module_button__1-61w","buttonActive":"low-quality-module_buttonActive__1Meca"};
styleInject(css_248z$6);

var ZuploaderLowQuality = function ZuploaderLowQuality(_a) {
  var _b;

  var images = _a.images;

  var _c = useContext(ZuploaderContext),
      touploads = _c.touploads,
      setTouploads = _c.setTouploads,
      setLowQualityImages = _c.setLowQualityImages;

  var _retains = useRef([]);

  var _d = useState(0),
      currentIndex = _d[0],
      setCurrentIndex = _d[1];

  console.log(images);
  useEffect(function () {
    if (currentIndex >= images.length) {
      setTouploads(touploads.concat(_retains.current));
      setLowQualityImages([]);
    }
  }, [currentIndex]);

  var handleImageSkip = function handleImageSkip() {
    _retains.current = _retains.current.concat(images.slice(currentIndex));
    setTouploads(touploads.concat(_retains.current));
    setLowQualityImages([]);
  };

  var handleImageKeep = function handleImageKeep() {
    _retains.current.push(images[currentIndex]);

    setCurrentIndex(currentIndex + 1);
    gtag('z_low_keep');
  };

  var handleImageRemove = function handleImageRemove() {
    setCurrentIndex(currentIndex + 1);
    gtag('z_low_remove');
  };

  return /*#__PURE__*/React.createElement(Drawer, {
    key: currentIndex,
    className: "zuploader-low-quality"
  }, /*#__PURE__*/React.createElement(Header, {
    closable: false,
    title: i18n$1.format('zuploader.low.quality.title'),
    contentClassName: styles$6.headerContent,
    renderExtra: images.length > 1 && /*#__PURE__*/React.createElement("div", {
      className: styles$6.headerExtra,
      onClick: handleImageSkip
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$6.skip
    }, i18n$1.format('zuploader.low.quality.skip')))
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$6.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$6.imageWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$6.image,
    style: {
      backgroundImage: "url(" + ((_b = images[currentIndex]) === null || _b === void 0 ? void 0 : _b.objectURL) + ")"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$6.tips
  }, i18n$1.format('zuploader.low.quality.tips')), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$6.button, styles$6.buttonActive),
    onClick: handleImageKeep
  }, i18n$1.format('zuploader.low.quality.keep')), /*#__PURE__*/React.createElement("div", {
    className: styles$6.button,
    onClick: handleImageRemove
  }, i18n$1.format('zuploader.low.quality.remove'))));
};

var css_248z$5 = ".zuploader-stock-photos {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.zuploader-stock-photos .stock-photos-module_headerExtra__3fZRe {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100%;\n  padding: 0 12px;\n}\n.zuploader-stock-photos .stock-photos-module_headerExtra__3fZRe svg {\n  width: 30px;\n  height: 30px;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1 {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  width: 100%;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1 .stock-photos-module_loading__3Ro4Q {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1 .stock-photos-module_loading__3Ro4Q svg > circle {\n  stroke: #313131;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryWrapper__3Od0i {\n  padding: 20px 20px 0;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryWrapper__3Od0i .stock-photos-module_loading__3Ro4Q {\n  padding-bottom: 20px;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryWrapper__3Od0i .stock-photos-module_stockCategory__3euyd {\n  position: relative;\n  width: 100%;\n  margin-bottom: 20px;\n  background-color: #d8d8d8;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  border-radius: 12px;\n  cursor: pointer;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryWrapper__3Od0i .stock-photos-module_stockCategory__3euyd::before {\n  display: block;\n  padding-top: 40%;\n  content: '';\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryWrapper__3Od0i .stock-photos-module_stockCategoryName__Jatqb {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  padding: 6px 20px;\n  color: #fff;\n  font-size: 16px;\n  text-transform: capitalize;\n  background: rgba(0, 0, 0, .8);\n  border-radius: 16px;\n  -webkit-transform: translate(-50%, -50%);\n      -ms-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n  -webkit-align-content: flex-start;\n      -ms-flex-line-pack: start;\n          align-content: flex-start;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_loading__3Ro4Q,\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_empty__3oziq {\n  padding: 20px;\n  color: #909399;\n  font-size: 14px;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0 {\n  position: relative;\n  width: 33.33333%;\n  background-color: #d8d8d8;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  border-right: 1px solid #f2f2f2;\n  border-bottom: 1px solid #f2f2f2;\n  cursor: pointer;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0:nth-child(3n) {\n  border-right-width: 0;\n}\n@media screen and (min-width: 768px) {\n  .zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0 {\n    width: 16.66667%;\n  }\n  .zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0:nth-child(3n) {\n    border-right-width: 1px;\n  }\n  .zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0:nth-child(6n) {\n    border-right-width: 0;\n  }\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0::before {\n  display: block;\n  padding-top: 100%;\n  content: '';\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0 .stock-photos-module_radioWrapper__w7EhA {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: none;\n  padding: 5px 5px 20px 20px;\n  cursor: pointer;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0 .stock-photos-module_radioWrapper__w7EhA .stock-photos-module_radio__2UhM1 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  min-width: 20px;\n  min-height: 20px;\n  padding: 0 5px;\n  background: rgba(0, 0, 0, .3);\n  border: 1px solid #fff;\n  border-radius: 50%;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0 .stock-photos-module_radioWrapper__w7EhA .stock-photos-module_radio__2UhM1 span {\n  display: none;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0 .stock-photos-module_radioWrapper__w7EhA.stock-photos-module_radioLarge__3ns97 {\n  padding: 3px 3px 20px 20px;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0 .stock-photos-module_radioWrapper__w7EhA.stock-photos-module_radioLarge__3ns97 .stock-photos-module_radio__2UhM1 {\n  padding: 4px 5px;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0 .stock-photos-module_radioWrapper__w7EhA.stock-photos-module_radioChecked__2txNa .stock-photos-module_radio__2UhM1 {\n  background: #ff533a;\n  border-color: #ff533a;\n}\n.zuploader-stock-photos .stock-photos-module_content__3Hap1.stock-photos-module_stockCategoryImageWrapper__1KS8A .stock-photos-module_stockCategoryImage__3Qu_0 .stock-photos-module_radioWrapper__w7EhA.stock-photos-module_radioChecked__2txNa .stock-photos-module_radio__2UhM1 span {\n  display: block;\n}\n.zuploader-stock-photos .stock-photos-module_footer__1x_bK {\n  display: none;\n  width: 100%;\n}\n.zuploader-stock-photos .stock-photos-module_footerContent__O6t7I {\n  position: relative;\n  z-index: 9;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 100%;\n  height: 60px;\n  padding: 0 12px;\n  background: #e4e7ed;\n}\n.zuploader-stock-photos .stock-photos-module_footerContent__O6t7I .stock-photos-module_expand__2bs7N {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 100%;\n  padding-right: 40px;\n  color: #909399;\n  font-size: 12px;\n  text-transform: capitalize;\n  cursor: pointer;\n}\n.zuploader-stock-photos .stock-photos-module_footerContent__O6t7I .stock-photos-module_expand__2bs7N svg {\n  width: 16px;\n  height: 16px;\n  margin-left: 4px;\n  fill: #909399;\n}\n.zuploader-stock-photos .stock-photos-module_footerContent__O6t7I .stock-photos-module_confirm__2D_mG {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 40px;\n  padding: 0 12px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  text-transform: uppercase;\n  background: #ff533a;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.zuploader-stock-photos .stock-photos-module_footerContent__O6t7I .stock-photos-module_confirm__2D_mG .stock-photos-module_imageCount__LT3Pv {\n  margin-left: 6px;\n  padding: 3px 4px;\n  color: #ff533a;\n  background: #fff;\n  border-radius: 3px;\n}\n.zuploader-stock-photos .stock-photos-module_footerExpand__u_qbj {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n  width: 100%;\n  padding: 20px 5px 60px;\n  background: #e4e7ed;\n}\n.zuploader-stock-photos .stock-photos-module_footerExpand__u_qbj .stock-photos-module_expandImage__2yuo5 {\n  position: relative;\n  width: calc(25% - 10px);\n  margin: 0 5px 10px;\n  background-color: rgba(0, 0, 0, .1);\n  background-position: center;\n  background-size: cover;\n  border-radius: 6px;\n}\n@media screen and (min-width: 768px) {\n  .zuploader-stock-photos .stock-photos-module_footerExpand__u_qbj .stock-photos-module_expandImage__2yuo5 {\n    width: calc(16.66667% - 10px);\n  }\n}\n.zuploader-stock-photos .stock-photos-module_footerExpand__u_qbj .stock-photos-module_expandImage__2yuo5::before {\n  display: block;\n  padding-top: 100%;\n  content: '';\n}\n.zuploader-stock-photos .stock-photos-module_footerExpand__u_qbj .stock-photos-module_expandImage__2yuo5::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border: 1px solid rgba(0, 0, 0, .3);\n  border-radius: 6px;\n  content: '';\n}\n.zuploader-stock-photos .stock-photos-module_footerExpand__u_qbj .stock-photos-module_expandImage__2yuo5 .stock-photos-module_closeWrapper__1PTrV {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 2px;\n  padding: 2px;\n  background: #ff533a;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi {\n  z-index: 11;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  background-color: #000;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_header__2BW7o {\n  border-bottom: none;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_header__2BW7o svg {\n  fill: #fff;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_header__2BW7o .stock-photos-module_headerExtra__3fZRe {\n  display: none;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100%;\n  padding: 0 12px;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_header__2BW7o .stock-photos-module_headerExtra__3fZRe .stock-photos-module_radio__2UhM1 {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 30px;\n  height: 30px;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_header__2BW7o .stock-photos-module_headerExtra__3fZRe .stock-photos-module_radio__2UhM1::before {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 22px;\n  height: 22px;\n  background: rgba(0, 0, 0, .3);\n  border: 2px solid #fff;\n  border-radius: 50%;\n  content: '';\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_header__2BW7o .stock-photos-module_headerExtra__3fZRe .stock-photos-module_radio__2UhM1 svg {\n  position: relative;\n  z-index: 1;\n  display: none;\n  width: 100%;\n  height: 100%;\n  fill: #ff533a;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_header__2BW7o .stock-photos-module_headerExtra__3fZRe .stock-photos-module_radio__2UhM1 svg > circle {\n  stroke: #ff533a;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_header__2BW7o .stock-photos-module_headerExtra__3fZRe .stock-photos-module_radio__2UhM1.stock-photos-module_radioChecked__2txNa::before {\n  background: #fff;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_header__2BW7o .stock-photos-module_headerExtra__3fZRe .stock-photos-module_radio__2UhM1.stock-photos-module_radioChecked__2txNa svg {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_footer__1x_bK {\n  position: absolute;\n  bottom: 0;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -webkit-align-items: flex-end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 100%;\n  padding: 20px 16px;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_footer__1x_bK .stock-photos-module_pexels__3ND45 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_footer__1x_bK .stock-photos-module_pexels__3ND45 .stock-photos-module_photographer__3JdXT {\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  text-decoration: none;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_footer__1x_bK .stock-photos-module_pexels__3ND45 .stock-photos-module_statement__2USij {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding-top: 4px;\n  text-transform: uppercase;\n  -webkit-transform: scale(0.8);\n      -ms-transform: scale(0.8);\n          transform: scale(0.8);\n  -webkit-transform-origin: left;\n      -ms-transform-origin: left;\n          transform-origin: left;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_footer__1x_bK .stock-photos-module_pexels__3ND45 .stock-photos-module_statement__2USij svg {\n  width: 24px;\n  height: 24px;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_footer__1x_bK .stock-photos-module_pexels__3ND45 .stock-photos-module_statement__2USij span {\n  padding-left: 6px;\n  color: #fff;\n  font-size: 12px;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_footer__1x_bK .stock-photos-module_pexels__3ND45 .stock-photos-module_statement__2USij span a {\n  color: #fff;\n  font-weight: 700;\n  text-decoration: none;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_footer__1x_bK .stock-photos-module_confirm__2D_mG {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 15px;\n  background: #ff533a;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.zuploader-stock-photos .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_footer__1x_bK .stock-photos-module_confirm__2D_mG svg {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 30px;\n  height: 30px;\n  fill: #fff;\n}\n.zuploader-stock-photos .stock-photos-module_searchWrapper__2qv60 {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, .9);\n}\n.zuploader-stock-photos .stock-photos-module_searchWrapper__2qv60 .stock-photos-module_header__2BW7o {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 12px;\n  background: #fff;\n}\n.zuploader-stock-photos .stock-photos-module_searchWrapper__2qv60 .stock-photos-module_header__2BW7o .stock-photos-module_inputWrapper__Tk8g7 {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  height: 36px;\n  background: #e4e7ed;\n  border-radius: 20px;\n}\n.zuploader-stock-photos .stock-photos-module_searchWrapper__2qv60 .stock-photos-module_header__2BW7o .stock-photos-module_inputWrapper__Tk8g7 input[type='text'] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 0 40px;\n  background: transparent;\n  border: none;\n}\n.zuploader-stock-photos .stock-photos-module_searchWrapper__2qv60 .stock-photos-module_header__2BW7o .stock-photos-module_inputWrapper__Tk8g7 input[type='text']:focus {\n  outline: none;\n}\n.zuploader-stock-photos .stock-photos-module_searchWrapper__2qv60 .stock-photos-module_header__2BW7o .stock-photos-module_inputWrapper__Tk8g7 .stock-photos-module_iconWrapper__3coI8 {\n  position: relative;\n  z-index: 2;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0 10px;\n}\n.zuploader-stock-photos .stock-photos-module_searchWrapper__2qv60 .stock-photos-module_header__2BW7o .stock-photos-module_inputWrapper__Tk8g7 .stock-photos-module_iconWrapper__3coI8 svg {\n  width: 24px;\n  height: 24px;\n}\n.zuploader-stock-photos .stock-photos-module_searchWrapper__2qv60 .stock-photos-module_header__2BW7o .stock-photos-module_inputWrapper__Tk8g7 .stock-photos-module_iconWrapper__3coI8.stock-photos-module_search__1IKCU > svg {\n  fill: #909399;\n}\n.zuploader-stock-photos .stock-photos-module_searchWrapper__2qv60 .stock-photos-module_header__2BW7o .stock-photos-module_inputWrapper__Tk8g7 .stock-photos-module_iconWrapper__3coI8.stock-photos-module_confirm__2D_mG > svg {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  fill: #ff533a;\n}\n.zuploader-stock-photos .stock-photos-module_searchWrapper__2qv60 .stock-photos-module_header__2BW7o .stock-photos-module_cancel__2s1_X {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: 16px;\n  color: #303133;\n  font-size: 14px;\n}\n.zuploader-stock-photos.zuploader-stock-photos-multiple .stock-photos-module_footer__1x_bK {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.zuploader-stock-photos.zuploader-stock-photos-multiple .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_headerExtra__3fZRe {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.zuploader-stock-photos.zuploader-stock-photos-multiple .stock-photos-module_stockImageWrapper__2JFvi .stock-photos-module_confirm__2D_mG {\n  display: none;\n}\n.zuploader-stock-photos.zuploader-stock-photos-multiple .stock-photos-module_stockCategoryImageWrapper__1KS8A > .stock-photos-module_stockCategoryImage__3Qu_0 > .stock-photos-module_radioWrapper__w7EhA {\n  display: block;\n}\n";
var styles$5 = {"headerExtra":"stock-photos-module_headerExtra__3fZRe","content":"stock-photos-module_content__3Hap1","loading":"stock-photos-module_loading__3Ro4Q","stockCategoryWrapper":"stock-photos-module_stockCategoryWrapper__3Od0i","stockCategory":"stock-photos-module_stockCategory__3euyd","stockCategoryName":"stock-photos-module_stockCategoryName__Jatqb","stockCategoryImageWrapper":"stock-photos-module_stockCategoryImageWrapper__1KS8A","empty":"stock-photos-module_empty__3oziq","stockCategoryImage":"stock-photos-module_stockCategoryImage__3Qu_0","radioWrapper":"stock-photos-module_radioWrapper__w7EhA","radio":"stock-photos-module_radio__2UhM1","radioLarge":"stock-photos-module_radioLarge__3ns97","radioChecked":"stock-photos-module_radioChecked__2txNa","footer":"stock-photos-module_footer__1x_bK","footerContent":"stock-photos-module_footerContent__O6t7I","expand":"stock-photos-module_expand__2bs7N","confirm":"stock-photos-module_confirm__2D_mG","imageCount":"stock-photos-module_imageCount__LT3Pv","footerExpand":"stock-photos-module_footerExpand__u_qbj","expandImage":"stock-photos-module_expandImage__2yuo5","closeWrapper":"stock-photos-module_closeWrapper__1PTrV","stockImageWrapper":"stock-photos-module_stockImageWrapper__2JFvi","header":"stock-photos-module_header__2BW7o","pexels":"stock-photos-module_pexels__3ND45","photographer":"stock-photos-module_photographer__3JdXT","statement":"stock-photos-module_statement__2USij","searchWrapper":"stock-photos-module_searchWrapper__2qv60","inputWrapper":"stock-photos-module_inputWrapper__Tk8g7","iconWrapper":"stock-photos-module_iconWrapper__3coI8","search":"stock-photos-module_search__1IKCU","cancel":"stock-photos-module_cancel__2s1_X"};
styleInject(css_248z$5);

var ZuploaderStockPhotos = function ZuploaderStockPhotos(_a) {
  var _b;

  var onClose = _a.onClose,
      onConfirm = _a.onConfirm;

  var _c = useContext(ZuploaderContext),
      multiple = _c.multiple,
      _d = _c.stockCategory,
      stockCategory = _d === void 0 ? defaultCategory : _d;

  var _categoryImageWrapper = useRef(null);

  var _search = useRef(null);

  var _pagination = useRef(1);

  var _client = createClient(stockClientKey);

  var _e = useState([]),
      selectedImages = _e[0],
      setSelectedImages = _e[1];

  var _f = useState([]),
      category = _f[0],
      setCategory = _f[1];

  var _g = useState(),
      currentCategory = _g[0],
      setCurrentCategory = _g[1];

  var _h = useState([]),
      categoryImages = _h[0],
      setCategoryImages = _h[1];

  var _j = useState(),
      currentCategoryImage = _j[0],
      setCurrentCategoryImage = _j[1];

  var _k = useState(false),
      loading = _k[0],
      setLoading = _k[1];

  var _l = useState(false),
      footerExpand = _l[0],
      setFooterExpand = _l[1];

  var _m = useState(false),
      searchVisible = _m[0],
      setSearchVisible = _m[1];

  useEffect(function () {
    setLoading(true);
    getCategoryList().then(function (data) {
      setCategory(data);
      setLoading(false);
    });
  }, []);
  useEffect(function () {
    if (currentCategory) getCategoryImageList();else setCategoryImages([]);
  }, [currentCategory]);

  var handleCategoryChange = function handleCategoryChange(category) {
    setCurrentCategory(category);
    gtag('z_stock_category', category.name);
  };

  var getCategoryList = function getCategoryList() {
    return Promise.all(stockCategory.map(function (item) {
      return _client.photos.search({
        query: item,
        per_page: 1
      }).then(function (data) {
        if (data.total_results > 0) return {
          name: item,
          image: data.photos[0].src.large,
          total: data.total_results
        };
        return {
          name: item
        };
      });
    }));
  };

  var getCategoryImageList = function getCategoryImageList(page) {
    var _a, _b;

    if (page === void 0) {
      page = 1;
    }

    if (categoryImages.length < ((_a = currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.total) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER)) {
      setLoading(true);

      _client.photos.search({
        query: (_b = currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name) !== null && _b !== void 0 ? _b : '',
        per_page: stockPageSize,
        page: page
      }).then(function (data) {
        if (data.photos.length > 0) {
          setCategoryImages(categoryImages.concat(data.photos));
          _pagination.current = data.page;
        }
      }).finally(function () {
        setLoading(false);
      });
    }
  };

  var handleCategoryImageScrollCapture = function handleCategoryImageScrollCapture() {
    if (_categoryImageWrapper.current) {
      var _a = _categoryImageWrapper.current,
          scrollTop = _a.scrollTop,
          scrollHeight = _a.scrollHeight,
          offsetHeight = _a.offsetHeight;
      if (scrollHeight - scrollTop - offsetHeight <= stockEndThreshold && !loading) getCategoryImageList(_pagination.current + 1);
    }
  };

  var renderStockContent = function renderStockContent() {
    if (currentCategory) return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Header, {
      contentClassName: styles$5.headerContent,
      title: currentCategory.name + " " + (currentCategory.total ? "(" + currentCategory.total + ")" : ''),
      onClose: function onClose() {
        return setCurrentCategory(undefined);
      }
    }), /*#__PURE__*/React.createElement("div", {
      ref: _categoryImageWrapper,
      className: classnames(styles$5.content, styles$5.stockCategoryImageWrapper),
      onScrollCapture: handleCategoryImageScrollCapture
    }, categoryImages.map(function (item, index) {
      var _a;

      var selectedIndex = selectedImages.findIndex(function (_a) {
        var id = _a.id;
        return id === item.id;
      });
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: styles$5.stockCategoryImage,
        style: {
          backgroundImage: "url(" + item.src.small + ")"
        },
        onClick: function onClick() {
          return setCurrentCategoryImage(item);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: classnames(styles$5.radioWrapper, (_a = {}, _a[styles$5.radioLarge] = selectedIndex + 1 >= 10, _a[styles$5.radioChecked] = selectedIndex > -1, _a)),
        onClick: function onClick(e) {
          return handleSelectedImagesChange(e, item);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$5.radio
      }, /*#__PURE__*/React.createElement("span", null, selectedIndex + 1))));
    }), categoryImages.length === 0 && !loading && /*#__PURE__*/React.createElement("span", {
      className: styles$5.empty
    }, i18n$1.format('zuploader.empty.title')), loading && /*#__PURE__*/React.createElement("div", {
      className: styles$5.loading
    }, /*#__PURE__*/React.createElement(Loading, {
      size: 20
    }))));
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Header, {
      contentClassName: styles$5.headerContent,
      title: i18n$1.format('zuploader.from.stock'),
      renderExtra: /*#__PURE__*/React.createElement("div", {
        className: styles$5.headerExtra,
        onClick: function onClick() {
          return setSearchVisible(true);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "search"
      })),
      onClose: onClose
    }), /*#__PURE__*/React.createElement("div", {
      className: classnames(styles$5.content, styles$5.stockCategoryWrapper)
    }, loading && /*#__PURE__*/React.createElement("div", {
      className: styles$5.loading
    }, /*#__PURE__*/React.createElement(Loading, {
      size: 20
    })), category.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: styles$5.stockCategory,
        style: {
          backgroundImage: "url(" + item.image + ")"
        },
        onClick: function onClick() {
          return handleCategoryChange(item);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$5.stockCategoryName
      }, item.name));
    })));
  };

  var handleSelectedImagesChange = function handleSelectedImagesChange(e, image) {
    if (image === void 0) {
      image = currentCategoryImage;
    }

    e.preventDefault();
    e.stopPropagation();

    if (image) {
      if (selectedImages.find(function (item) {
        return item.id === image.id;
      })) setSelectedImages(selectedImages.filter(function (item) {
        return item.id !== image.id;
      }));else {
        setSelectedImages(selectedImages.concat(image));
        gtag('z_stock_choose');
      }
    }
  };

  var handleSearch = function handleSearch() {
    var _a;

    var value = (_a = _search.current) === null || _a === void 0 ? void 0 : _a.value;

    if (value) {
      setCurrentCategory({
        name: value
      });
      setSearchVisible(false);
      gtag('z_stock_tap_search', value);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classnames('zuploader-stock-photos', {
      'zuploader-stock-photos-multiple': multiple
    })
  }, renderStockContent(), selectedImages.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles$5.footer
  }, footerExpand && /*#__PURE__*/React.createElement(Drawer, {
    className: styles$5.footerExpand,
    onClose: function onClose() {
      return setFooterExpand(false);
    }
  }, selectedImages.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles$5.expandImage,
      style: {
        backgroundImage: "url(" + item.src.small + ")"
      },
      onClick: function onClick(e) {
        return handleSelectedImagesChange(e, item);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$5.closeWrapper
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "close",
      size: 14,
      color: "#fff"
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$5.footerContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$5.expand,
    onClick: function onClick() {
      return setFooterExpand(!footerExpand);
    }
  }, footerExpand ? /*#__PURE__*/React.createElement(Icon, {
    type: "down"
  }) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", null, "Show All"), /*#__PURE__*/React.createElement(Icon, {
    type: "up"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$5.confirm,
    onClick: function onClick() {
      return onConfirm(selectedImages);
    }
  }, i18n$1.format('zuploader.confirm'), /*#__PURE__*/React.createElement("div", {
    className: styles$5.imageCount
  }, "3")))), currentCategoryImage && /*#__PURE__*/React.createElement(Drawer, {
    className: styles$5.stockImageWrapper,
    mask: false,
    style: {
      backgroundImage: "url(" + currentCategoryImage.src.large + ")"
    }
  }, /*#__PURE__*/React.createElement(Header, {
    className: styles$5.header,
    closeIconType: "down",
    onClose: function onClose() {
      return setCurrentCategoryImage(undefined);
    },
    renderExtra: /*#__PURE__*/React.createElement("div", {
      className: styles$5.headerExtra,
      onClick: handleSelectedImagesChange
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(styles$5.radio, (_b = {}, _b[styles$5.radioChecked] = selectedImages.find(function (item) {
        return item.id === currentCategoryImage.id;
      }), _b))
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "confirm-circle"
    })))
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$5.footer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$5.pexels
  }, /*#__PURE__*/React.createElement("a", {
    rel: "noreferrer",
    className: styles$5.photographer,
    href: currentCategoryImage.photographer_url,
    target: "_blank"
  }, currentCategoryImage.photographer), /*#__PURE__*/React.createElement("div", {
    className: styles$5.statement
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "pexels"
  }), /*#__PURE__*/React.createElement("span", null, i18n$1.format('zuploader.power.by'), ' ', /*#__PURE__*/React.createElement("a", {
    rel: "noreferrer",
    href: "https://www.pexels.com",
    target: "_blank"
  }, "pexels")))), /*#__PURE__*/React.createElement("div", {
    className: styles$5.confirm,
    onClick: function onClick() {
      return onConfirm([currentCategoryImage]);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "confirm"
  })))), searchVisible && /*#__PURE__*/React.createElement("div", {
    className: styles$5.searchWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$5.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$5.inputWrapper
  }, /*#__PURE__*/React.createElement("input", {
    ref: _search,
    type: "text",
    autoFocus: true
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$5.iconWrapper, styles$5.search)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "search"
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$5.iconWrapper, styles$5.confirm),
    onClick: handleSearch
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "confirm"
  }))), /*#__PURE__*/React.createElement("span", {
    className: styles$5.cancel
  }, i18n$1.format('zuploader.cancel')))));
};

var css_248z$4 = ".zuploader-wrapper {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 99999999;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background: transparent !important;\n}\n.zuploader-wrapper.wrapper-module_mask__3nD5H {\n  background: rgba(0, 0, 0, .65) !important;\n  -webkit-animation: wrapper-module_mask__3nD5H 0.2s linear;\n          animation: wrapper-module_mask__3nD5H 0.2s linear;\n}\n@-webkit-keyframes wrapper-module_mask__3nD5H {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes wrapper-module_mask__3nD5H {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.zuploader-wrapper .wrapper-module_content__fOv9z {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n}\n@media screen and (min-width: 768px) {\n  .zuploader-wrapper .wrapper-module_content__fOv9z {\n    width: 480px;\n    height: 600px;\n    overflow: hidden;\n    border-radius: 6px;\n    -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .1), 0 2px 5px 0 rgba(0, 0, 0, .2);\n            box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .1), 0 2px 5px 0 rgba(0, 0, 0, .2);\n    -webkit-animation: wrapper-module_bubbles__2nd3S 0.2s cubic-bezier(0.33, 1, 0.68, 1);\n            animation: wrapper-module_bubbles__2nd3S 0.2s cubic-bezier(0.33, 1, 0.68, 1);\n  }\n}\n@-webkit-keyframes wrapper-module_bubbles__2nd3S {\n  from {\n    -webkit-transform: scale(0, 0);\n            transform: scale(0, 0);\n  }\n  to {\n    -webkit-transform: scale(1, 1);\n            transform: scale(1, 1);\n  }\n}\n@keyframes wrapper-module_bubbles__2nd3S {\n  from {\n    -webkit-transform: scale(0, 0);\n            transform: scale(0, 0);\n  }\n  to {\n    -webkit-transform: scale(1, 1);\n            transform: scale(1, 1);\n  }\n}\n";
var styles$4 = {"-webkit-mask":"wrapper-module_mask__3nD5H","mask":"wrapper-module_mask__3nD5H","content":"wrapper-module_content__fOv9z","bubbles":"wrapper-module_bubbles__2nd3S"};
styleInject(css_248z$4);

var ZuploaderWrapper = function ZuploaderWrapper(_a) {
  var _b;

  var mask = _a.mask,
      children = _a.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('zuploader-wrapper', (_b = {}, _b[styles$4.mask] = mask, _b))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.content
  }, children));
};

var css_248z$3 = ".zuploader-file-stack {\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.zuploader-file-stack .file-stack-module_closeWrapper__O_pZc {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 9;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 14px;\n  cursor: pointer;\n}\n.zuploader-file-stack .file-stack-module_closeWrapper__O_pZc svg {\n  width: 24px;\n  height: 24px;\n  fill: #555555;\n}\n.zuploader-file-stack .fsp-picker {\n  z-index: 1 !important;\n}\n.zuploader-file-stack .fsp-picker .fsp-modal {\n  z-index: auto !important;\n}\n.zuploader-file-stack .fsp-loading--folder::after {\n  display: none;\n}\n.zuploader-file-stack .file-stack-module_fileStackContent__34Jrs {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: transparent;\n}\n";
var styles$3 = {"closeWrapper":"file-stack-module_closeWrapper__O_pZc","fileStackContent":"file-stack-module_fileStackContent__34Jrs"};
styleInject(css_248z$3);

var ZuploadFileStack = function ZuploadFileStack(_a, ref) {
  var onClose = _a.onClose,
      onConfirm = _a.onConfirm;
  var multiple = useContext(ZuploaderContext).multiple;

  var _picker = useRef(null);

  useImperativeHandle(ref, function () {
    return {
      close: function close() {
        var _a;

        (_a = _picker.current) === null || _a === void 0 ? void 0 : _a.close();
      }
    };
  });
  useEffect(function () {
    var _a;

    var client = filestack.init(fileStackKey);
    _picker.current = client.picker({
      container: '#zuploader-fs',
      displayMode: filestack.PickerDisplayMode.inline,
      accept: 'image/*',
      fromSources: ['facebook', 'instagram', 'googledrive'],
      maxFiles: multiple ? 1000 : 1,
      onOpen: onOpen,
      onUploadDone: function onUploadDone(_a) {
        var filesUploaded = _a.filesUploaded;
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_b) {
            onConfirm(filesUploaded.map(function (item) {
              return item.url;
            }));
            return [2];
          });
        });
      }
    });
    (_a = _picker.current) === null || _a === void 0 ? void 0 : _a.open();
  }, []);

  var onOpen = function onOpen() {
    requestAnimationFrame(function () {
      var doms = document.getElementsByClassName('fsp-mobile-menu');
      if (doms.length > 0) doms[0].click();else onOpen();
    });
  };

  var handleClose = function handleClose() {
    var _a;

    (_a = _picker.current) === null || _a === void 0 ? void 0 : _a.close();
    onClose();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "zuploader-file-stack"
  }, /*#__PURE__*/React.createElement("div", {
    id: "zuploader-fs",
    className: styles$3.fileStackContent
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$3.closeWrapper,
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  })), /*#__PURE__*/React.createElement(Loading, null));
};

var FileStack = /*#__PURE__*/forwardRef(ZuploadFileStack);

var css_248z$2 = ".zuploader-image-cropper {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.zuploader-image-cropper .image-cropper-module_headerExtra__2bx0C {\n  height: 100%;\n  padding: 10px 12px;\n}\n.zuploader-image-cropper .image-cropper-module_headerExtra__2bx0C .image-cropper-module_confirm__2LE9o {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100%;\n  padding: 0 16px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  text-transform: uppercase;\n  background: #ff533a;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm {\n  height: calc(100% - 150px);\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container {\n  width: 100%;\n  height: 100%;\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-view-box {\n  outline: 0;\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-center {\n  display: none;\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-dashed {\n  border-color: #fff;\n  border-style: solid;\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-line {\n  opacity: 0;\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-point {\n  width: 20px;\n  height: 20px;\n  background: transparent;\n  border: 4px solid #ff533a;\n  opacity: 1;\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-point.point-e,\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-point.point-n,\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-point.point-w,\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-point.point-s {\n  display: none;\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-point.point-ne {\n  border-bottom-width: 0;\n  border-left-width: 0;\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-point.point-se {\n  border-top-width: 0;\n  border-left-width: 0;\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-point.point-sw {\n  border-top-width: 0;\n  border-right-width: 0;\n}\n.zuploader-image-cropper .image-cropper-module_content__3eYAm .cropper-container .cropper-point.point-nw {\n  border-right-width: 0;\n  border-bottom-width: 0;\n}\n.zuploader-image-cropper .image-cropper-module_vernier__2HUU- {\n  position: relative;\n  height: 50px;\n}\n.zuploader-image-cropper .image-cropper-module_vernierCursor__3qDc1 {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 10px;\n  pointer-events: none;\n}\n.zuploader-image-cropper .image-cropper-module_vernierCursor__3qDc1 span {\n  color: #ff533a;\n  font-weight: 700;\n  font-size: 12px;\n  -webkit-transform: scale(0.8);\n      -ms-transform: scale(0.8);\n          transform: scale(0.8);\n  -webkit-transform-origin: center;\n      -ms-transform-origin: center;\n          transform-origin: center;\n}\n.zuploader-image-cropper .image-cropper-module_vernierCursor__3qDc1::after {\n  width: 2px;\n  height: 20px;\n  background: #ff533a;\n  border-radius: 1px;\n  content: '';\n}\n.zuploader-image-cropper .image-cropper-module_vernierContent__1412Y {\n  height: 100%;\n  overflow-x: auto;\n  cursor: ew-resize;\n}\n.zuploader-image-cropper .image-cropper-module_vernierContent__1412Y::-webkit-scrollbar {\n  display: none;\n}\n.zuploader-image-cropper .image-cropper-module_vernierContent__1412Y .image-cropper-module_indicatorWrapper__30km2 {\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: end;\n  -webkit-align-items: flex-end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  height: 100%;\n  padding: 0 50% 10px;\n}\n.zuploader-image-cropper .image-cropper-module_vernierContent__1412Y .image-cropper-module_indicatorWrapper__30km2 .image-cropper-module_indicator__3DvcL {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 6px;\n  height: 10px;\n}\n.zuploader-image-cropper .image-cropper-module_vernierContent__1412Y .image-cropper-module_indicatorWrapper__30km2 .image-cropper-module_indicator__3DvcL::after {\n  width: 1px;\n  height: 100%;\n  background: #c0c4cc;\n  content: '';\n}\n.zuploader-image-cropper .image-cropper-module_vernierContent__1412Y .image-cropper-module_indicatorWrapper__30km2 .image-cropper-module_indicator__3DvcL:nth-child(5n) {\n  height: 15px;\n}\n.zuploader-image-cropper .image-cropper-module_vernierContent__1412Y .image-cropper-module_indicatorWrapper__30km2 .image-cropper-module_indicator__3DvcL:nth-child(5n)::after {\n  background: #909399;\n}\n.zuploader-image-cropper .image-cropper-module_vernierContent__1412Y .image-cropper-module_indicatorWrapper__30km2 .image-cropper-module_indicator__3DvcL:first-child {\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  width: 3.5px;\n}\n.zuploader-image-cropper .image-cropper-module_vernierContent__1412Y .image-cropper-module_indicatorWrapper__30km2 .image-cropper-module_indicator__3DvcL:last-child {\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 3.5px;\n  height: 10px;\n}\n.zuploader-image-cropper .image-cropper-module_vernierContent__1412Y .image-cropper-module_indicatorWrapper__30km2 .image-cropper-module_indicator__3DvcL:last-child::after {\n  background: #c0c4cc;\n}\n.zuploader-image-cropper .image-cropper-module_footer__PsiHJ {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 40px;\n  padding: 5px;\n}\n.zuploader-image-cropper .image-cropper-module_footer__PsiHJ .image-cropper-module_iconWrapper__1107d {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100%;\n  margin: 0 5px;\n  background: #e4e7ed;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.zuploader-image-cropper .image-cropper-module_footer__PsiHJ .image-cropper-module_iconWrapper__1107d svg {\n  width: 20px;\n  height: 20px;\n  fill: #606266;\n}\n.zuploader-image-cropper .image-cropper-module_footer__PsiHJ .image-cropper-module_replace__GwMgY {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 48%;\n  height: 100%;\n  margin: 0 5px;\n  background: rgba(255, 83, 58, .1);\n  border-radius: 3px;\n  cursor: pointer;\n}\n.zuploader-image-cropper .image-cropper-module_footer__PsiHJ .image-cropper-module_replace__GwMgY span {\n  color: #ff533a;\n  font-weight: 700;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n.zuploader-image-cropper .image-cropper-module_footer__PsiHJ .image-cropper-module_replace__GwMgY input[type='file'] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n";
var styles$2 = {"headerExtra":"image-cropper-module_headerExtra__2bx0C","confirm":"image-cropper-module_confirm__2LE9o","content":"image-cropper-module_content__3eYAm","vernier":"image-cropper-module_vernier__2HUU-","vernierCursor":"image-cropper-module_vernierCursor__3qDc1","vernierContent":"image-cropper-module_vernierContent__1412Y","indicatorWrapper":"image-cropper-module_indicatorWrapper__30km2","indicator":"image-cropper-module_indicator__3DvcL","footer":"image-cropper-module_footer__PsiHJ","iconWrapper":"image-cropper-module_iconWrapper__1107d","replace":"image-cropper-module_replace__GwMgY"};
styleInject(css_248z$2);

var ZuploaderImageCropper = function ZuploaderImageCropper(_a) {
  var image = _a.image,
      width = _a.width,
      height = _a.height,
      _b = _a.maxWidth,
      maxWidth = _b === void 0 ? 2048 : _b,
      _c = _a.maxHeight,
      maxHeight = _c === void 0 ? 2048 : _c,
      aspectRatio = _a.aspectRatio,
      cropperData = _a.cropperData,
      onClose = _a.onClose,
      onConfirm = _a.onConfirm;
  var setTouploads = useContext(ZuploaderContext).setTouploads;

  var _image = useRef(null);

  var _vernier = useRef(null);

  var _cropper = useRef();

  var _d = useState(0),
      rotate = _d[0],
      setRotate = _d[1];

  useEffect(function () {
    if (_image.current) {
      if (width && height) aspectRatio = width / height;
      _cropper.current = new Cropper(_image.current, {
        data: cropperData,
        viewMode: 1,
        dragMode: 'move',
        background: false,
        aspectRatio: aspectRatio,
        initialAspectRatio: 1,
        checkOrientation: false
      });
    }

    if (_vernier.current) {
      var _a = _vernier.current,
          scrollWidth = _a.scrollWidth,
          clientWidth = _a.clientWidth;

      var _center = (scrollWidth - clientWidth - 6) / 2;

      _vernier.current.scrollTo(_center, 0);
    }
  }, []);

  var handleVernierScrollCapture = function handleVernierScrollCapture() {
    if (_vernier.current) {
      var _a = _vernier.current,
          scrollLeft = _a.scrollLeft,
          scrollWidth = _a.scrollWidth,
          clientWidth = _a.clientWidth;

      var _center = (scrollWidth - clientWidth - 6) / 2;

      setRotate(Math.round((scrollLeft - _center) / 6));
    }
  };

  useEffect(function () {
    var _a;

    (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.rotateTo(rotate);
  }, [rotate]);

  var handleImageReplace = function handleImageReplace(event) {
    return __awaiter(void 0, void 0, void 0, function () {
      var files, image;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            files = event.target.files || [];
            return [4, createZuploaderImage(files[0], ZuploaderSource.album)];

          case 1:
            image = _b.sent();
            setTouploads([image]);
            (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.replace(image.objectURL);
            return [2];
        }
      });
    });
  };

  var handleReset = function handleReset() {
    var _a;

    (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.reset();

    if (_vernier.current) {
      var _b = _vernier.current,
          scrollWidth = _b.scrollWidth,
          clientWidth = _b.clientWidth;

      var _center = (scrollWidth - clientWidth - 6) / 2;

      _vernier.current.scrollTo(_center, 0);

      setRotate(0);
    }
  };

  var handleZoomIn = function handleZoomIn() {
    var _a;

    (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.zoom(0.1);
  };

  var handleZoomOut = function handleZoomOut() {
    var _a;

    (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.zoom(-0.1);
  };

  var handleConfirm = function handleConfirm() {
    if (_cropper.current) {
      var canvas_1 = _cropper.current.getCroppedCanvas({
        width: width,
        height: height,
        maxWidth: maxWidth,
        maxHeight: maxHeight
      });

      var cropperData_1 = _cropper.current.getData();

      canvas_1.toBlob(function (blob) {
        if (blob) {
          onConfirm({
            cropperData: cropperData_1,
            width: cropperData_1.width,
            height: cropperData_1.height,
            objectURL: createObjectURL(blob),
            source: ZuploaderSource.album,
            retryCount: 0
          });
          disposeCanvas(canvas_1);
        }
      });
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "zuploader-image-cropper"
  }, /*#__PURE__*/React.createElement(Header, {
    closeIconType: "left",
    onClose: onClose,
    renderExtra: /*#__PURE__*/React.createElement("div", {
      className: styles$2.headerExtra,
      onClick: handleConfirm
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$2.confirm
    }, "confirm"))
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$2.content
  }, /*#__PURE__*/React.createElement("img", {
    ref: _image,
    src: image.objectURL
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$2.vernier
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.vernierCursor
  }, /*#__PURE__*/React.createElement("span", null, rotate)), /*#__PURE__*/React.createElement("div", {
    ref: _vernier,
    className: styles$2.vernierContent,
    onScrollCapture: handleVernierScrollCapture
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.indicatorWrapper
  }, Array.from({
    length: 180
  }).map(function (_, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles$2.indicator
    });
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles$2.footer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.iconWrapper,
    onClick: handleZoomIn
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "zoom-in"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$2.iconWrapper,
    onClick: handleZoomOut
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "zoom-out"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$2.iconWrapper,
    onClick: handleReset
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "reset"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$2.replace
  }, /*#__PURE__*/React.createElement("span", null, i18n$1.format('zuploader.replace.photo')), /*#__PURE__*/React.createElement("input", {
    type: "file",
    onChange: handleImageReplace
  }))));
};

var css_248z$1 = ".zuploader-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.zuploader-image .image-module_content__37tg6 {\n  height: calc(100% - 120px);\n  padding: 40px 40px 100px;\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ.image-module_imageUploading__34zEG .image-module_progressWrapper__3ig_k {\n  display: block;\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ img {\n  position: relative;\n  max-width: 100%;\n  height: 100%;\n  border: 1px solid rgba(0, 0, 0, .2);\n  border-radius: 6px;\n  -webkit-box-shadow: 0 3px 5px rgba(0, 0, 0, .15);\n          box-shadow: 0 3px 5px rgba(0, 0, 0, .15);\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ .image-module_progressWrapper__3ig_k {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  overflow: hidden;\n  border-radius: 6px;\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ .image-module_progressWrapper__3ig_k .image-module_progress__2845t {\n  position: absolute;\n  top: -50%;\n  right: -50%;\n  bottom: -50%;\n  left: -50%;\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ .image-module_progressWrapper__3ig_k .image-module_progress__2845t svg {\n  width: 100%;\n  height: 100%;\n  -webkit-transform: scale(1, -1) rotate(90deg);\n      -ms-transform: scale(1, -1) rotate(90deg);\n          transform: scale(1, -1) rotate(90deg);\n  fill: none;\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ .image-module_progressWrapper__3ig_k .image-module_progress__2845t svg circle {\n  stroke: rgba(0, 0, 0, .6);\n  stroke-width: 50;\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ .image-module_lowQuality__3HlOw {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 3px 8px;\n  background: #e73d3d;\n  border: 1px solid #fff;\n  border-radius: 18px;\n  -webkit-box-shadow: 0 1px 18px rgba(231, 61, 61, .12), 0 3px 5px -1px rgba(231, 61, 61, .2), 0 6px 10px rgba(231, 61, 61, .14);\n          box-shadow: 0 1px 18px rgba(231, 61, 61, .12), 0 3px 5px -1px rgba(231, 61, 61, .2), 0 6px 10px rgba(231, 61, 61, .14);\n  -webkit-transform: translate(-50%, -50%);\n      -ms-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ .image-module_lowQuality__3HlOw svg {\n  width: 20px;\n  height: 20px;\n  fill: #fff;\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ .image-module_lowQuality__3HlOw span {\n  padding: 0 4px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 12px;\n  white-space: nowrap;\n  text-transform: capitalize;\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ .image-module_handle__NUP6m {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 20px;\n  -webkit-transform: translate(-50%, 100%);\n      -ms-transform: translate(-50%, 100%);\n          transform: translate(-50%, 100%);\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ .image-module_handle__NUP6m .image-module_iconWrapper__YNJtp {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0 10px;\n  padding: 5px;\n  border: 1px solid rgba(0, 0, 0, .1);\n  border-radius: 50%;\n  cursor: pointer;\n}\n.zuploader-image .image-module_content__37tg6 .image-module_imageWrapper__24xPG .image-module_image___bjaZ .image-module_handle__NUP6m .image-module_iconWrapper__YNJtp svg {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 30px;\n  height: 30px;\n  fill: #000;\n}\n.zuploader-image .image-module_footer__2MGyF {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  height: 60px;\n  padding: 0 12px;\n  background: #e4e7ed;\n  border-top: 1px solid rgba(0, 0, 0, .05);\n  -webkit-transition: height 0.2s;\n  -o-transition: height 0.2s;\n  transition: height 0.2s;\n}\n.zuploader-image .image-module_footer__2MGyF.image-module_footerHide__17QfD {\n  height: 0;\n  overflow: hidden;\n  border: none;\n}\n.zuploader-image .image-module_footer__2MGyF .image-module_button__1ijVb {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 40px;\n  font-size: 14px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.zuploader-image .image-module_footer__2MGyF .image-module_button__1ijVb.image-module_replace__1dh2b {\n  min-width: 30%;\n  margin-right: 16px;\n  padding: 0 12px;\n  color: #606266;\n  text-transform: capitalize;\n  border: 1px solid rgba(0, 0, 0, .2);\n}\n.zuploader-image .image-module_footer__2MGyF .image-module_button__1ijVb.image-module_replace__1dh2b input[type='file'] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n.zuploader-image .image-module_footer__2MGyF .image-module_button__1ijVb.image-module_confirm__1plgV {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  background: #ff533a;\n}\n.zuploader-image .image-module_footer__2MGyF .image-module_button__1ijVb.image-module_confirm__1plgV span {\n  color: #fff;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n";
var styles$1 = {"content":"image-module_content__37tg6","imageWrapper":"image-module_imageWrapper__24xPG","image":"image-module_image___bjaZ","imageUploading":"image-module_imageUploading__34zEG","progressWrapper":"image-module_progressWrapper__3ig_k","progress":"image-module_progress__2845t","lowQuality":"image-module_lowQuality__3HlOw","handle":"image-module_handle__NUP6m","iconWrapper":"image-module_iconWrapper__YNJtp","footer":"image-module_footer__2MGyF","footerHide":"image-module_footerHide__17QfD","button":"image-module_button__1ijVb","replace":"image-module_replace__1dh2b","confirm":"image-module_confirm__1plgV"};
styleInject(css_248z$1);

var ZuploaderImage = function ZuploaderImage(_a) {
  var _b, _c;

  var image = _a.image,
      uploading = _a.uploading,
      renderHeader = _a.renderHeader,
      onUploadConfirm = _a.onUploadConfirm;

  var _d = useContext(ZuploaderContext),
      upload = _d.upload,
      setTouploads = _d.setTouploads,
      lowQualityThreshold = _d.lowQualityThreshold;

  var _wrapper = useRef(null);

  var _e = useState(image),
      source = _e[0],
      setSource = _e[1];

  var _f = useState(false),
      cropperVisible = _f[0],
      setCropperVisble = _f[1];

  var _g = useState(false),
      lowQualityVisible = _g[0],
      setLowQualityVisible = _g[1];

  var _h = useState(),
      maxHeight = _h[0],
      setMaxHeight = _h[1];

  useEffect(function () {
    var _a;

    setMaxHeight((_a = _wrapper.current) === null || _a === void 0 ? void 0 : _a.offsetHeight);
  }, []);
  useEffect(function () {
    setSource(image);
  }, [image]);
  useEffect(function () {
    var _a = source.width,
        width = _a === void 0 ? 0 : _a,
        _b = source.height,
        height = _b === void 0 ? 0 : _b;
    setLowQualityVisible(width < lowQualityThreshold || height < lowQualityThreshold);
  }, [source]);

  var handleImageReplace = function handleImageReplace(event) {
    return __awaiter(void 0, void 0, void 0, function () {
      var files, image;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            files = event.target.files || [];
            return [4, createZuploaderImage(files[0], ZuploaderSource.album)];

          case 1:
            image = _a.sent();
            setTouploads([image]);
            gtag('z_tools_replace');
            return [2];
        }
      });
    });
  };

  var handleCropperTap = function handleCropperTap() {
    setCropperVisble(true);
    gtag('z_tools_crop');
  };

  var handleImageOrientationChange = function handleImageOrientationChange(orientation) {
    return __awaiter(void 0, void 0, void 0, function () {
      var image, canvas, ctx, rotate;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, loadImage(source.objectURL)];

          case 1:
            image = _a.sent();
            canvas = document.createElement('canvas');
            ctx = canvas.getContext('2d');
            canvas.width = image.height;
            canvas.height = image.width;
            rotate = orientation === 'left' ? -90 : 90;
            ctx === null || ctx === void 0 ? void 0 : ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx === null || ctx === void 0 ? void 0 : ctx.rotate(rotate * Math.PI / 180);
            ctx === null || ctx === void 0 ? void 0 : ctx.translate(-canvas.height / 2, -canvas.width / 2);
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvas.height, canvas.width);
            canvas.toBlob(function (blob) {
              if (blob) {
                setSource({
                  width: canvas.width,
                  height: canvas.height,
                  objectURL: createObjectURL(blob),
                  source: ZuploaderSource.album,
                  retryCount: 0
                });
                disposeCanvas(canvas);
              }
            });
            gtag("z_tools_rotate_" + orientation);
            return [2];
        }
      });
    });
  };

  var handleCropperConfirm = function handleCropperConfirm(image) {
    setSource(image);
    setCropperVisble(false);
  };

  var _j = image.percent,
      percent = _j === void 0 ? 0 : _j;
  return /*#__PURE__*/React.createElement("div", {
    className: "zuploader-image"
  }, renderHeader, /*#__PURE__*/React.createElement("div", {
    className: styles$1.content
  }, /*#__PURE__*/React.createElement("div", {
    ref: _wrapper,
    className: styles$1.imageWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$1.image, (_b = {}, _b[styles$1.imageUploading] = uploading, _b))
  }, /*#__PURE__*/React.createElement("img", {
    src: source === null || source === void 0 ? void 0 : source.objectURL,
    style: {
      maxHeight: maxHeight
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$1.progressWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.progress
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("circle", {
    r: "25",
    cx: "50",
    cy: "50",
    strokeDasharray: (100 - percent) * 158 / 100 + " 158"
  })))), lowQualityVisible && /*#__PURE__*/React.createElement("div", {
    className: styles$1.lowQuality
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "warning"
  }), /*#__PURE__*/React.createElement("span", null, i18n$1.format('zuploader.low.quality.title'))), !uploading && /*#__PURE__*/React.createElement("div", {
    className: styles$1.handle
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$1.iconWrapper, styles$1.crop),
    onClick: handleCropperTap
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "crop"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$1.iconWrapper,
    onClick: function onClick() {
      return handleImageOrientationChange('left');
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "rotate-left"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$1.iconWrapper,
    onClick: function onClick() {
      return handleImageOrientationChange('right');
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "rotate-right"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$1.footer, (_c = {}, _c[styles$1.footerHide] = uploading, _c))
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$1.button, styles$1.replace)
  }, /*#__PURE__*/React.createElement("span", null, i18n$1.format('zuploader.replace')), /*#__PURE__*/React.createElement("input", {
    type: "file",
    onChange: handleImageReplace
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$1.button, styles$1.confirm),
    onClick: function onClick() {
      return onUploadConfirm([source]);
    }
  }, /*#__PURE__*/React.createElement("span", null, upload ? i18n$1.format('zuploader.upload.now') : i18n$1.format('zuploader.confirm')))), cropperVisible && /*#__PURE__*/React.createElement(ZuploaderImageCropper, {
    image: image,
    cropperData: source.cropperData,
    onClose: function onClose() {
      return setCropperVisble(false);
    },
    onConfirm: handleCropperConfirm
  }));
};

var css_248z = "[class^='zuploader'] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background: #f2f2f2;\n}\n[class^='zuploader'] * {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-weight: 400;\n  font-family: 'Roboto';\n  line-height: 1;\n}\n.zuploader {\n  position: relative;\n}\n.zuploader .index-module_headerTitleExtra__379-X {\n  color: #909399;\n  font-size: 12px;\n}\n.zuploader .index-module_headerTitleExtra__379-X.index-module_headerTitleExtraLoading__kTV_l {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #ff533a;\n}\n.zuploader .index-module_headerTitleExtra__379-X.index-module_headerTitleExtraLoading__kTV_l span {\n  padding: 0 4px;\n}\n.zuploader .index-module_headerTitleExtra__379-X.index-module_headerTitleExtraLoading__kTV_l svg > circle {\n  stroke: #ff533a;\n}\n.zuploader .index-module_headerExtra__3stxj {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding-right: 12px;\n}\n.zuploader .index-module_headerExtra__3stxj .index-module_limitCount__sE27B {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 2px 8px;\n  line-height: 1;\n  background: rgba(255, 83, 58, .1);\n  border: 1px solid rgba(255, 83, 58, .2);\n  border-radius: 16px;\n}\n.zuploader .index-module_headerExtra__3stxj .index-module_limitCount__sE27B b {\n  color: #ff533a;\n  font-weight: 700;\n  line-height: 20px;\n}\n.zuploader .index-module_headerExtra__3stxj .index-module_limitCount__sE27B span {\n  padding-left: 2px;\n  color: rgba(255, 83, 58, .7);\n  font-size: 12px;\n}\n.zuploader .index-module_content__2Lb53 {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  padding: 20px;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q {\n  margin-bottom: 20px;\n  overflow: hidden;\n  background: #fff;\n  border-radius: 6px;\n  -webkit-box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px rgba(0, 0, 0, .14), 0 1px 3px rgba(0, 0, 0, .12);\n          box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .2), 0 1px 1px rgba(0, 0, 0, .14), 0 1px 3px rgba(0, 0, 0, .12);\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q.index-module_channelGroupLimit__2_ubf {\n  background: #ff533a;\n  -webkit-box-shadow: 0 2px 1px -1px rgba(255, 83, 58, .8), 0 1px 1px rgba(255, 83, 58, .86), 0 1px 3px rgba(255, 83, 58, .88);\n          box-shadow: 0 2px 1px -1px rgba(255, 83, 58, .8), 0 1px 1px rgba(255, 83, 58, .86), 0 1px 3px rgba(255, 83, 58, .88);\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q.index-module_channelGroupLimit__2_ubf .index-module_channel__3InO6 {\n  position: relative;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q.index-module_channelGroupLimit__2_ubf .index-module_channelContent__aDE75 {\n  color: #fff;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q.index-module_channelGroupLimit__2_ubf .index-module_channelContent__aDE75 span {\n  font-weight: 700;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q.index-module_channelGroupLimit__2_ubf .index-module_channelContent__aDE75 small {\n  color: #fff;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q.index-module_channelGroupLimit__2_ubf .index-module_channel__3InO6 svg {\n  fill: #fff;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channel__3InO6 {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 15px 12px 15px 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, .14);\n  cursor: pointer;\n}\n@media screen and (min-width: 768px) {\n  .zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channel__3InO6.index-module_channelCamera__1aDRp {\n    display: none;\n  }\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channel__3InO6.index-module_channelAlbum__2cfnH > svg {\n  fill: #626ab3;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channel__3InO6.index-module_channelCamera__1aDRp > svg {\n  fill: #9c645b;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channel__3InO6.index-module_channelStock__zf16X > svg {\n  fill: #6c896d;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channel__3InO6.index-module_channelCloud__14X_N > svg {\n  fill: #70b5e3;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channel__3InO6:last-child {\n  border-bottom: 0;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channelContent__aDE75 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  color: #1a191e;\n  font-size: 16px;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channelContent__aDE75 small {\n  color: #ff533a;\n  font-size: 12px;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channel__3InO6 input[type='file'] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channelSocial__2rLU6 {\n  padding: 12px;\n  text-align: center;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channelSocialContent__1S7VG {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channelSocialContent__1S7VG svg {\n  width: 20px;\n  margin: 0 5px 8px;\n}\n.zuploader .index-module_content__2Lb53 .index-module_channelGroup__tiM8Q .index-module_channelSocial__2rLU6 span {\n  font-size: 14px;\n}\n.zuploader .index-module_footer__3j4cY {\n  padding: 20px;\n}\n.zuploader .index-module_footer__3j4cY .index-module_buttonCancel__gfjds {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n  height: 48px;\n  color: #909399;\n  font-size: 14px;\n  text-transform: capitalize;\n  background: rgba(0, 0, 0, .05);\n  border: 0;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.zuploader .index-module_footer__3j4cY .index-module_buttonCancel__gfjds:focus {\n  outline: none;\n}\n.zuploader-list .index-module_image__2FAaS {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  border-radius: 6px;\n}\n.zuploader-list .index-module_image__2FAaS::before {\n  display: block;\n  padding-top: 100%;\n  content: '';\n}\n.zuploader-list .index-module_image__2FAaS::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border: 1px solid rgba(0, 0, 0, .2);\n  border-radius: 6px;\n  content: '';\n}\n.zuploader-list .index-module_image__2FAaS.index-module_imageTupload__2_tnp {\n  opacity: 0.3;\n}\n.zuploader-list .index-module_image__2FAaS.index-module_imageTupload__2_tnp .index-module_progress__26uBE,\n.zuploader-list .index-module_image__2FAaS.index-module_imageTupload__2_tnp .index-module_iconWrapper__HyDvK.index-module_close__k_WLV {\n  display: none;\n}\n.zuploader-list .index-module_image__2FAaS.index-module_imageUploading__on9vE .index-module_iconWrapper__HyDvK.index-module_close__k_WLV {\n  display: none;\n}\n.zuploader-list .index-module_image__2FAaS.index-module_imageUploading__on9vE .index-module_progress__26uBE {\n  display: block;\n}\n.zuploader-list .index-module_image__2FAaS.index-module_imageUploadDone__1GCFw .index-module_progress__26uBE,\n.zuploader-list .index-module_image__2FAaS.index-module_imageUploadDone__1GCFw .index-module_iconWrapper__HyDvK.index-module_close__k_WLV {\n  display: none;\n}\n.zuploader-list .index-module_image__2FAaS.index-module_imageUploadDone__1GCFw .index-module_iconWrapper__HyDvK.index-module_confirm__1XXDq {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.zuploader-list .index-module_imageContent__2iFyN {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.zuploader-list .index-module_imageContent__2iFyN .index-module_progress__26uBE {\n  position: absolute;\n  top: -25%;\n  right: -25%;\n  bottom: -25%;\n  left: -25%;\n  display: none;\n}\n.zuploader-list .index-module_imageContent__2iFyN .index-module_progress__26uBE svg {\n  width: 100%;\n  height: 100%;\n  -webkit-transform: scale(1, -1) rotate(90deg);\n      -ms-transform: scale(1, -1) rotate(90deg);\n          transform: scale(1, -1) rotate(90deg);\n  fill: none;\n}\n.zuploader-list .index-module_imageContent__2iFyN .index-module_progress__26uBE svg circle {\n  stroke: rgba(0, 0, 0, .6);\n  stroke-width: 50;\n}\n.zuploader-list .index-module_imageContent__2iFyN .index-module_iconWrapper__HyDvK {\n  position: relative;\n}\n.zuploader-list .index-module_imageContent__2iFyN .index-module_iconWrapper__HyDvK svg {\n  position: relative;\n  z-index: 1;\n  width: 20px;\n  height: 20px;\n}\n.zuploader-list .index-module_imageContent__2iFyN .index-module_iconWrapper__HyDvK.index-module_close__k_WLV > svg {\n  cursor: pointer;\n  fill: #ff533a;\n}\n.zuploader-list .index-module_imageContent__2iFyN .index-module_iconWrapper__HyDvK.index-module_confirm__1XXDq {\n  display: none;\n}\n.zuploader-list .index-module_imageContent__2iFyN .index-module_iconWrapper__HyDvK.index-module_confirm__1XXDq svg {\n  fill: #67c23a;\n}\n.zuploader-list .index-module_imageContent__2iFyN .index-module_iconWrapper__HyDvK.index-module_confirm__1XXDq svg > circle {\n  stroke: #67c23a;\n}\n.zuploader-list .index-module_imageContent__2iFyN .index-module_iconWrapper__HyDvK::before {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: 50%;\n  content: '';\n}\n.zuploader-list .index-module_footer__3j4cY {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  height: 60px;\n  padding: 0 12px 0 16px;\n  overflow: hidden;\n  background: #e4e7ed;\n  -webkit-box-shadow: inset 0 1px 0 rgba(0, 0, 0, .05);\n          box-shadow: inset 0 1px 0 rgba(0, 0, 0, .05);\n  -webkit-transition: height 0.2s;\n  -o-transition: height 0.2s;\n  transition: height 0.2s;\n}\n.zuploader-list .index-module_footer__3j4cY.index-module_footerHide__3McdW {\n  height: 0;\n}\n.zuploader-list .index-module_footer__3j4cY .index-module_addPhotos__3F5BB {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #ff533a;\n  font-size: 14px;\n  text-transform: capitalize;\n  cursor: pointer;\n}\n.zuploader-list .index-module_footer__3j4cY .index-module_addPhotos__3F5BB svg {\n  width: 16px;\n  height: 16px;\n  fill: #ff533a;\n}\n.zuploader-list .index-module_footer__3j4cY .index-module_addPhotos__3F5BB input[type='file'] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n.zuploader-list .index-module_footer__3j4cY .index-module_confirmButton__3G-xH {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 40px;\n  padding: 0 12px;\n  background: #ff533a;\n  border: 0;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.zuploader-list .index-module_footer__3j4cY .index-module_confirmButton__3G-xH span {\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  text-transform: uppercase;\n}\n.zuploader-list .index-module_footer__3j4cY .index-module_confirmButton__3G-xH .index-module_imageCount__25olJ {\n  margin-left: 6px;\n  padding: 3px 4px;\n  color: #ff533a;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 14px;\n  background: #fff;\n  border-radius: 3px;\n}\n";
var styles = {"headerTitleExtra":"index-module_headerTitleExtra__379-X","headerTitleExtraLoading":"index-module_headerTitleExtraLoading__kTV_l","headerExtra":"index-module_headerExtra__3stxj","limitCount":"index-module_limitCount__sE27B","content":"index-module_content__2Lb53","channelGroup":"index-module_channelGroup__tiM8Q","channelGroupLimit":"index-module_channelGroupLimit__2_ubf","channel":"index-module_channel__3InO6","channelContent":"index-module_channelContent__aDE75","channelCamera":"index-module_channelCamera__1aDRp","channelAlbum":"index-module_channelAlbum__2cfnH","channelStock":"index-module_channelStock__zf16X","channelCloud":"index-module_channelCloud__14X_N","channelSocial":"index-module_channelSocial__2rLU6","channelSocialContent":"index-module_channelSocialContent__1S7VG","footer":"index-module_footer__3j4cY","buttonCancel":"index-module_buttonCancel__gfjds","image":"index-module_image__2FAaS","imageTupload":"index-module_imageTupload__2_tnp","progress":"index-module_progress__26uBE","iconWrapper":"index-module_iconWrapper__HyDvK","close":"index-module_close__k_WLV","imageUploading":"index-module_imageUploading__on9vE","imageUploadDone":"index-module_imageUploadDone__1GCFw","confirm":"index-module_confirm__1XXDq","imageContent":"index-module_imageContent__2iFyN","footerHide":"index-module_footerHide__3McdW","addPhotos":"index-module_addPhotos__3F5BB","confirmButton":"index-module_confirmButton__3G-xH","imageCount":"index-module_imageCount__25olJ"};
styleInject(css_248z);

var ZuploaderContext = /*#__PURE__*/React.createContext({
  touploads: [],
  setTouploads: function setTouploads() {},
  setLowQualityImages: function setLowQualityImages() {},
  stockCategory: [],
  lowQualityThreshold: 0,
  gtag: function gtag() {}
});

var Zuploader = function Zuploader(_a) {
  var local = _a.local,
      upload = _a.upload,
      autoUpload = _a.autoUpload,
      multiple = _a.multiple,
      stockCategory = _a.stockCategory,
      enableCloud = _a.enableCloud,
      minCount = _a.minCount,
      limitCountTips = _a.limitCountTips,
      _b = _a.allowAdjust,
      allowAdjust = _b === void 0 ? true : _b,
      _c = _a.lowQualityThreshold,
      lowQualityThreshold = _c === void 0 ? 800 : _c,
      _d = _a.onClose,
      onClose = _d === void 0 ? function () {} : _d,
      onConfirm = _a.onConfirm;

  var _fileStack = useRef(null);

  var _e = useState(false),
      render = _e[1];

  var _f = useState([]),
      touploads = _f[0],
      setTouploads = _f[1];

  var _g = useState(false),
      touploadVisible = _g[0],
      setTouploadVisible = _g[1];

  var _h = useState(false),
      uploading = _h[0],
      setUploading = _h[1];

  var _j = useState(false),
      fileStackVisible = _j[0],
      setFileStackVisible = _j[1];

  var _k = useState([]),
      lowQualityImages = _k[0],
      setLowQualityImages = _k[1];

  var _l = useState(false),
      stockPhotosVisible = _l[0],
      setStockPhotosVisible = _l[1];

  var _m = useState(false),
      downloadVisible = _m[0],
      setDownloadVisible = _m[1];

  var _o = useState([]),
      downloads = _o[0],
      setDownloads = _o[1];

  useEffect(function () {
    GA.initialize(gaid);
  }, []);
  useEffect(function () {
    i18n$1.setLocal(local);
    render(true);
  }, [local]);
  useEffect(function () {
    if (touploads.length > 0) {
      if (upload || allowAdjust) setTouploadVisible(true);else handleUploadConfirm();
    } else setTouploadVisible(false);
  }, [touploads]);

  var handleaAlbumChange = function handleaAlbumChange(event) {
    return __awaiter(void 0, void 0, void 0, function () {
      var files, images, _images_1, _lowQualitys_1;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            files = event.target.files || [];
            return [4, Promise.all(Array.from({
              length: files.length || 0
            }).map(function (_, index) {
              return createZuploaderImage(files[index], ZuploaderSource.album);
            }))];

          case 1:
            images = _a.sent();

            if (multiple) {
              _images_1 = [];
              _lowQualitys_1 = [];
              images.forEach(function (item) {
                if (item.width < lowQualityThreshold || item.height < lowQualityThreshold) _lowQualitys_1.push(item);else _images_1.push(item);
              });
              setTouploads(_images_1);
              setLowQualityImages(_lowQualitys_1);
            } else setTouploads(images);

            gtag('z_tap_album');
            return [2];
        }
      });
    });
  };

  var handleCameraChange = function handleCameraChange(event) {
    return __awaiter(void 0, void 0, void 0, function () {
      var files, images;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            files = event.target.files || [];
            return [4, Promise.all(Array.from({
              length: files.length || 0
            }).map(function (_, index) {
              return createZuploaderImage(files[index], ZuploaderSource.camera);
            }))];

          case 1:
            images = _a.sent();
            setTouploads(images);
            gtag('z_tap_camera');
            return [2];
        }
      });
    });
  };

  var handleStockVisibleChange = function handleStockVisibleChange(visible) {
    setStockPhotosVisible(visible);
    if (visible) gtag('z_tap_stock');else gtag('z_stock_close');
  };

  var handleCloudTap = function handleCloudTap() {
    gtag('z_tap_cloud');
  };

  var handleFileStackTap = function handleFileStackTap() {
    setFileStackVisible(true);
    gtag('z_tap_social');
  };

  useEffect(function () {
    if (touploadVisible && upload && autoUpload) handleUploadConfirm();
  }, [touploadVisible]);

  var handleListAddImages = function handleListAddImages(event) {
    return __awaiter(void 0, void 0, void 0, function () {
      var files, images, _images, _lowQualitys;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            files = event.target.files || [];
            return [4, Promise.all(Array.from({
              length: files.length || 0
            }).map(function (_, index) {
              return createZuploaderImage(files[index], ZuploaderSource.album);
            }))];

          case 1:
            images = _a.sent();
            _images = [];
            _lowQualitys = [];
            images.forEach(function (item) {
              if (item.width < lowQualityThreshold || item.height < lowQualityThreshold) _lowQualitys.push(item);else _images.push(item);
            });
            setTouploads(touploads.concat(_images));
            setLowQualityImages(_lowQualitys);
            gtag('z_add_photo');
            return [2];
        }
      });
    });
  };

  var handleListDeleteImages = function handleListDeleteImages(image) {
    setTouploads(touploads.filter(function (item) {
      return item !== image;
    }));
  };

  var uploadImage = function uploadImage(image, filename, token) {
    return new Promise(function (resolve) {
      var _uploadImage = function _uploadImage() {
        return __awaiter(void 0, void 0, void 0, function () {
          var resp, _a;

          var _c;

          return __generator(this, function (_d) {
            switch (_d.label) {
              case 0:
                _d.trys.push([0, 3,, 4]);

                _a = upload7n;
                _c = {
                  token: token,
                  key: filename
                };
                return [4, urlToBlob(image.objectURL)];

              case 1:
                return [4, _a.apply(void 0, [(_c.file = _d.sent(), _c), function (percent) {
                  image.percent = Math.min(percent, 80);
                  setTouploads(clonedeep(touploads));
                }])];

              case 2:
                resp = _d.sent();
                image.percent = 100;
                setTouploads(clonedeep(touploads));
                resolve({
                  url: host7n['prefix-na0'] + resp.key,
                  objectURL: image.objectURL,
                  width: image.width,
                  height: image.height,
                  source: image.source
                });
                return [3, 4];

              case 3:
                _d.sent();

                if (image.retryCount < 2) {
                  image.retryCount++;
                  setTouploads(clonedeep(touploads));

                  _uploadImage();
                } else {
                  setTouploads(clonedeep(touploads));
                  resolve(undefined);
                }

                return [3, 4];

              case 4:
                return [2];
            }
          });
        });
      };

      _uploadImage();
    });
  };

  var handleUploadConfirm = function handleUploadConfirm(images) {
    if (images === void 0) {
      images = touploads;
    }

    return __awaiter(void 0, void 0, void 0, function () {
      var token_1, key_1, results;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!upload) return [3, 6];
            _b.label = 1;

          case 1:
            _b.trys.push([1, 4,, 5]);

            setUploading(true);
            return [4, getToken7n()];

          case 2:
            token_1 = _b.sent();
            key_1 = createKey();
            return [4, Promise.all(images.map(function (item, index) {
              return uploadImage(item, key_1 + "-" + index + ".jpg", token_1);
            }))];

          case 3:
            results = _b.sent();
            onConfirm(results.filter(function (item) {
              return item !== undefined;
            }));
            return [3, 5];

          case 4:
            _b.sent();
            alert('zuploader.upload.error');
            setUploading(false);
            return [3, 5];

          case 5:
            return [3, 7];

          case 6:
            onConfirm(images.map(function (_a) {
              var objectURL = _a.objectURL,
                  width = _a.width,
                  height = _a.height,
                  source = _a.source;
              return {
                width: width,
                height: height,
                objectURL: objectURL,
                source: source
              };
            }));
            _b.label = 7;

          case 7:
            onClose();
            gtag('z_button_upload');
            return [2];
        }
      });
    });
  };

  var downloadImages = function downloadImages() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2, Promise.all(downloads.map(function (item) {
          return __awaiter(void 0, void 0, void 0, function () {
            var objectURL, _a, width, height;

            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  if (!item.url) return [3, 3];
                  return [4, download(item.url, function (present) {
                    item.percent = present;
                    setDownloads(clonedeep(downloads));
                  })];

                case 1:
                  objectURL = _b.sent();
                  return [4, loadImage(objectURL)];

                case 2:
                  _a = _b.sent(), width = _a.width, height = _a.height;
                  return [2, Object.assign(item, {
                    width: width,
                    height: height,
                    objectURL: objectURL
                  })];

                case 3:
                  return [2, undefined];
              }
            });
          });
        })).then(function (images) {
          return images.filter(function (_) {
            return !!_;
          });
        })];
      });
    });
  };

  useEffect(function () {
    if (downloadVisible) downloadImages().then(function (images) {
      var _a;

      onConfirm(images);
      onClose();
      (_a = _fileStack.current) === null || _a === void 0 ? void 0 : _a.close();
    });
  }, [downloadVisible]);

  var handleClose = function handleClose() {
    onClose();
    gtag('z_tap_close');
  };

  var handleStockPhotosConfirm = function handleStockPhotosConfirm(images) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        setDownloads(images.map(function (item) {
          return {
            url: item.src.large2x,
            source: ZuploaderSource.stock
          };
        }));
        setDownloadVisible(true);
        return [2];
      });
    });
  };

  var handleFileStackConfirm = function handleFileStackConfirm(images) {
    setDownloads(images.map(function (item) {
      return {
        url: item,
        source: ZuploaderSource.social
      };
    }));
    setDownloadVisible(true);
  };

  var handleDownloadCancel = function handleDownloadCancel() {
    setDownloads([]);
    setDownloadVisible(false);
    gtag('z_stock_download_stop');
  };

  var renderTuploadContent = function renderTuploadContent() {
    var _a;

    if (!touploadVisible) return;

    var titleExtra = function titleExtra() {
      if (!upload) return;
      if (uploading) return /*#__PURE__*/React.createElement("span", {
        className: classnames(styles.headerTitleExtra, styles.headerTitleExtraLoading)
      }, /*#__PURE__*/React.createElement(Loading, {
        size: 12
      }), /*#__PURE__*/React.createElement("span", null, i18n$1.format('zuploader.subtitle.uploading'), "..."));
      return /*#__PURE__*/React.createElement("span", {
        className: styles.headerTitleExtra
      }, i18n$1.format('zuploader.subtitle.wait.upload'));
    };

    var header = /*#__PURE__*/React.createElement(Header, {
      title: "Choose photos source",
      onClose: function onClose() {
        return setTouploadVisible(false);
      },
      renderTitleExtra: titleExtra(),
      renderExtra: minCount && /*#__PURE__*/React.createElement("div", {
        className: styles.headerExtra
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.limitCount
      }, /*#__PURE__*/React.createElement("b", null, touploads.length), /*#__PURE__*/React.createElement("span", null, "/", minCount)))
    });
    if (multiple) return /*#__PURE__*/React.createElement(ZuploaderList, {
      images: touploads,
      renderHeader: header,
      renderImageContent: function renderImageContent(item) {
        var _a;

        var objectURL = item.objectURL,
            _b = item.percent,
            percent = _b === void 0 ? 0 : _b;
        return /*#__PURE__*/React.createElement("div", {
          className: classnames(styles.image, (_a = {}, _a[styles.imageTupload] = uploading && percent === 0, _a[styles.imageUploading] = uploading && percent > 0, _a[styles.imageUploadDone] = percent === 100, _a)),
          style: {
            backgroundImage: "url(" + objectURL + ")"
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.imageContent
        }, /*#__PURE__*/React.createElement("div", {
          className: classnames(styles.iconWrapper, styles.close),
          onClick: function onClick() {
            return handleListDeleteImages(item);
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "close-circle"
        })), /*#__PURE__*/React.createElement("div", {
          className: classnames(styles.iconWrapper, styles.confirm)
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "confirm-circle"
        })), /*#__PURE__*/React.createElement("div", {
          className: styles.progress
        }, /*#__PURE__*/React.createElement("svg", {
          viewBox: "0 0 100 100"
        }, /*#__PURE__*/React.createElement("circle", {
          r: "25",
          cx: "50",
          cy: "50",
          strokeDasharray: (100 - percent) * 158 / 100 + " 158"
        })))));
      },
      renderFooter: /*#__PURE__*/React.createElement("div", {
        className: classnames(styles.footer, (_a = {}, _a[styles.footerHide] = uploading, _a))
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.addPhotos
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "add"
      }), /*#__PURE__*/React.createElement("span", null, i18n$1.format('zuploader.add.photos')), /*#__PURE__*/React.createElement("input", {
        type: "file",
        accept: "image/*",
        multiple: true,
        onChange: handleListAddImages
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.confirmButton,
        onClick: function onClick() {
          return handleUploadConfirm();
        }
      }, /*#__PURE__*/React.createElement("span", null, upload ? i18n$1.format('zuploader.upload') : i18n$1.format('zuploader.confirm')), /*#__PURE__*/React.createElement("div", {
        className: styles.imageCount
      }, touploads.length)))
    });else return /*#__PURE__*/React.createElement(ZuploaderImage, {
      image: touploads[0],
      uploading: uploading,
      renderHeader: header,
      onUploadConfirm: handleUploadConfirm
    });
  };

  return /*#__PURE__*/React.createElement(ZuploaderContext.Provider, {
    value: {
      multiple: multiple,
      upload: upload,
      touploads: touploads,
      setTouploads: setTouploads,
      stockCategory: stockCategory,
      setLowQualityImages: setLowQualityImages,
      lowQualityThreshold: lowQualityThreshold,
      gtag: gtag
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "zuploader"
  }, /*#__PURE__*/React.createElement(Header, {
    title: i18n$1.format('zuploader.choose.source.title'),
    onClose: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, minCount && /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.channelGroup, styles.channelGroupLimit)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.channel
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.channelContent
  }, limitCountTips ? /*#__PURE__*/React.createElement("span", null, limitCountTips) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", null, i18n$1.format('zuploader.min.count.title', minCount)), /*#__PURE__*/React.createElement("small", null, i18n$1.format('zuploader.min.count.subtitle', minCount)))), /*#__PURE__*/React.createElement(Icon, {
    type: "warning",
    size: 30
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.channelGroup
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.channel, styles.channelAlbum)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.channelContent
  }, i18n$1.format('zuploader.from.album')), /*#__PURE__*/React.createElement(Icon, {
    type: "album",
    size: 30
  }), /*#__PURE__*/React.createElement("input", {
    type: "file",
    accept: "image/*",
    multiple: multiple,
    onChange: handleaAlbumChange
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.channel, styles.channelCamera)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.channelContent
  }, i18n$1.format('zuploader.from.camera')), /*#__PURE__*/React.createElement(Icon, {
    type: "camera",
    size: 30
  }), /*#__PURE__*/React.createElement("input", {
    type: "file",
    accept: "image/*",
    capture: "camera",
    onChange: handleCameraChange
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.channel, styles.channelStock),
    onClick: function onClick() {
      return handleStockVisibleChange(true);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.channelContent
  }, /*#__PURE__*/React.createElement("span", null, i18n$1.format('zuploader.from.stock')), /*#__PURE__*/React.createElement("small", null, i18n$1.format('zuploader.from.stock.subtitle'))), /*#__PURE__*/React.createElement(Icon, {
    type: "pexels",
    size: 30
  }))), enableCloud && /*#__PURE__*/React.createElement("div", {
    className: styles.channelGroup,
    onClick: handleCloudTap
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.channel, styles.channelCloud)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.channelContent
  }, i18n$1.format('zuploader.from.cloud')), /*#__PURE__*/React.createElement(Icon, {
    type: "cloud",
    size: 30
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.channelGroup,
    onClick: handleFileStackTap
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.channelSocial
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.channelSocialContent
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "facebook"
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "instagram"
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "google-driver"
  })), /*#__PURE__*/React.createElement("span", null, i18n$1.format('zuploader.from.social'))))), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles.buttonCancel,
    onClick: handleClose
  }, /*#__PURE__*/React.createElement("span", null, i18n$1.format('zuploader.cancel')))), renderTuploadContent(), lowQualityImages.length > 0 && /*#__PURE__*/React.createElement(ZuploaderLowQuality, {
    images: lowQualityImages
  }), stockPhotosVisible && /*#__PURE__*/React.createElement(ZuploaderStockPhotos, {
    onClose: function onClose() {
      return handleStockVisibleChange(false);
    },
    onConfirm: handleStockPhotosConfirm
  }), fileStackVisible && /*#__PURE__*/React.createElement(FileStack, {
    ref: _fileStack,
    onClose: function onClose() {
      return setFileStackVisible(false);
    },
    onConfirm: handleFileStackConfirm
  }), downloadVisible && /*#__PURE__*/React.createElement(ZuploaderDownload, {
    images: downloads,
    onCancel: handleDownloadCancel
  })));
};

var render = function render(props) {
  var renderDom = document.getElementById('sunzi-zuploader');

  if (!renderDom) {
    var dom = document.createElement('div');
    dom.id = 'sunzi-zuploader';
    document.body.appendChild(dom);
    renderDom = document.getElementById('sunzi-zuploader');
  }

  var ref = /*#__PURE__*/React.createRef();

  var mask = props.mask,
      _a = props.onClose,
      _onClose = _a === void 0 ? function () {} : _a,
      others = __rest(props, ["mask", "onClose"]);

  var Component = /*#__PURE__*/React.createElement(ZuploaderWrapper, {
    mask: mask
  }, /*#__PURE__*/React.createElement(Zuploader, __assign(__assign({}, others), {
    onClose: function onClose() {
      renderDom === null || renderDom === void 0 ? void 0 : renderDom.remove();

      _onClose();
    }
  })));
  ReactDOM.render(Component, renderDom);
  return ref;
};

export default Zuploader;
export { ZuploaderContext, ZuploaderWrapper, render };
